<template>
    <v-container class="px-5 py-5" fluid v-if="this.$store.state.signedIn">
        <v-layout wrap justify-center>
            <v-flex xs12 md10>
                <v-card>
                    <OldRules></OldRules>
                    <v-toolbar dark flat color="secondary">
                        <v-toolbar-title @click="showOrgPrefs=!showOrgPrefs"> {{organisation}} Restricted Prefixes</v-toolbar-title>
                        <v-progress-circular v-if="loading" indeterminate color="white"></v-progress-circular>
                        <v-spacer></v-spacer>

                        <v-flex shrink align-center justify-center>
                            <br />
                            <v-switch v-model="showOrgFilters" @change="OrgFiltersChange()">
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main"><b>Show/Hide Filters</b></div>
                                </template>
                            </v-switch>
                        </v-flex>
                        <v-flex shrink align-center justify-center>
                            <br />
                            <v-switch v-model="showAdvanced" @change="advancedChange()">
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main"><b>Advanced settings</b></div>
                                </template>
                            </v-switch>
                        </v-flex>

                        <v-btn 
                            small 
                            dark 
                            color="success" 
                            @click="ClickPrepareDownload('org')"
                            > <v-icon>save_alt</v-icon> Org Prefixes </v-btn>
                        <v-btn @click="clickPrefix('Click here to add prefix', '', '', 0, '', 'organisation', '', '', '', '')" color="success" > Add prefix <v-icon>add</v-icon></v-btn>
                        <info>
                            <template slot>
                                Add/Change/Delete controlled prefixes to your organisation
                            </template>
                            <template slot="body">
                                The alerting mechanism works in the following way: <br />
                                
                                <p> <h2> SIMPLE ALERTING (no advanced settings) </h2> </p>
                                <ul>
                                    <li> The user defines a prefix, give it a name (for housekeeping), and will be alerted upon ownership assertions involing this prefix i.e. where the ownership has changed </li>
                                    <li> You will <b>not receive emails</b> and alerts are created <b>regardless of hijack and impact scores</b> created by the system. Alerts will come through with an Impact score overriden to <b>80.</b></li> 
                                </ul>

                                <p> <h2> ADVANCED ALERTING (advanced settings) </h2> </p>
                                <ul>
                                    <li> User can specify <b>which event types to be alerted upon</b>, of which there are 3 in total: 
                                        <ul>
                                            <li><b>Ownership Assertions</b></li>
                                            <li><b>Path Changes</b></li>
                                            <li><b>First Seens</b></li>
                                        </ul>
                                        There are descriptions of each of these in <b>hover over panels throughout the page - hover your cursor where you see any of these terms</b>
                                    </li>
                                    <li> The user can also decide whether to receive emails from these alerts, again split out by the event type </li>
                                    <li> When an alert occurs with emails turned on, an initial email is sent out, alerting the user of the alert beginning. </li>
                                    <li> You can choose to associate an ASN to the prefix, purely for housekeeping</li>
                                    <li> The user can set the <b>Impact score</b> that alerts will receive for the given prefix</li>

                                    
                                </ul>
                                <p>
                                    <b> Any alerts triggered by organisation prefixes will appear in your view of BGP Spotlight, and will be visible to 
                                        all other users in your organisation.
                                    </b>
                                </p>

                                <p><h2> FILTERS and BULK CHANGES </h2></p>
                                <ul>
                                    <li> Where a user wants to limit what is displayed or carry out bulk changes on the Organisation entries, the <b>SHOW/HIDE FILTERS</b> option opens an initial view that shows FILTER options where the IP Address or Name can be used to filter the display. (<b>The filter results show "beginning with" matches.</b>)</li>
                                    <li> Where bulk operations are required, such as changes or deletions, the <b>SHOW/HIDE BULK OPTIONS</b> allows changes to be made against all of the entries or just the filtered set. Additionally, entries can be deleted in the same way.</li>
                                    <li> NOTE: The DOWNLOAD option will download the filtered records only. i.e. with no filter, all entries will be downloaded. Similarly, the DELETE option will delete the filtered entries only.</li>
                                </ul>

                            </template>
                        </info>

                    </v-toolbar>
                        
                    <v-layout v-if="showOrgFilters" justify-center align-center class="px-0 py-0">
                            <v-form ref="OrgFilterForm" v-model="valid" lazy-validation>
                                <v-layout wrap justify-center row>
                                    <v-flex xs3 class="px-2">
                                        <v-text-field 
                                            :style="$store.state.textFormatting.main" 
                                            v-model="OrgFilterForm.name" 
                                            label="Filter by Name"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 class="px-2">
                                        <v-text-field 
                                            :style="$store.state.textFormatting.main" 
                                            v-model="OrgFilterForm.ip_address" 
                                            label="Filter by IP Prefix"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 class="px-2">
                                        <v-btn
                                        :disabled="!valid"
                                        color="success"
                                        @click="ApplyOrgFilter"
                                        >
                                        Apply
                                        </v-btn>
                                    </v-flex>   
                                    <v-flex xs3 class="px-2" align-center justify-center>
                                        <v-switch v-model="showOrgBulkUpdate">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main"><b>Show/Hide Bulk Update Options</b></div>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                    </v-layout>


                    <v-layout v-if="showOrgBulkUpdate && showOrgFilters" justify-center align-center class="xs-12 px-0 py-0">
                        <v-container>

                            <v-form ref="OrgBulkForm" >
                                <v-layout wrap align-center row class="px-0 py-0">
                                    <v-flex xs2 align-center>
                                        <v-radio-group v-model="bulkOrgForm.ImpactSetting" label="Impact Setting">
                                            <v-radio label="No Change" value="mixed"></v-radio>
                                            <v-radio label="Set Value" value="set"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs4 class="px-2">
                                        <v-subheader class="pl-0">Impact Score Value (Current range :  {{ bulkOrgForm.ImpactMin }} to {{ bulkOrgForm.ImpactMax }})</v-subheader>
                                        <v-slider :disabled="this.bulkOrgForm.ImpactSetting=='mixed'" v-model="bulkOrgForm.ImpactValue" thumb-label="always" min="0" max="99"></v-slider>
                                    </v-flex>
                                    <v-flex xs6 class="px-2" align-center >
                                        <v-layout wrap justify-end row class="px-0 py-0">
                                            <p>Apply changes to Filtererd Rules: ( {{ totalOrgResults }} entries )
                                            <v-btn
                                            :disabled="!valid"
                                            color="success"
                                            @click="showBulkUpdateOrg=true;"
                                            >Apply Changes</v-btn></p>
                                        </v-layout> 
                                        <v-layout wrap justify-end row class="px-0 py-0">
                                            <p>DELETE Filtererd Rules: ( {{ totalOrgResults }} entries )
                                            <v-btn
                                            :disabled="!valid"
                                            color="red"
                                            @click="showBulkDeleteOrg=true;"
                                            >DELETE FILTERED</v-btn></p>
                                        </v-layout> 
                                    </v-flex>

                                </v-layout>

                                <v-layout wrap justify-center row class="px-0 py-0">
                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Ownership Assertions?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has changed.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-radio-group v-model="bulkOrgForm.Assertions" @change="displayOrgBulkUpdateMessage=false" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkOrgForm.AssertionsCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkOrgForm.AssertionsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay mixed" value="mixed" :disabled="bulkOrgForm.AssertionsMixedDisabled"></v-radio>
                                                    <v-radio label="Alert on all" value="set"></v-radio>
                                                    <v-radio label="No Alerts" value="notset">
                                                    </v-radio>
                                                </v-radio-group>
                                                <v-radio-group v-model="bulkOrgForm.IntraOrg" @change="displayOrgBulkUpdateMessage=false"  :disabled="bulkOrgForm.Assertions!='mixed' && bulkOrgForm.Assertions!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Intra-Org Assertions</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Excluded </td><td>: {{ bulkOrgForm.IntraOrgCount_Set }}</td></tr>
                                                                <tr><td>Included </td><td>: {{ bulkOrgForm.IntraOrgCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay mixed" value="mixed" :disabled="bulkOrgForm.IntraOrgMixedDisabled"></v-radio>
                                                    <v-radio label="Exclude all" value="set"></v-radio>
                                                    <v-radio label="Include all" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex >
                                                <v-radio-group v-model="bulkOrgForm.AssertionEmails" @change="displayOrgBulkUpdateMessage=false"  :disabled="bulkOrgForm.Assertions!='mixed' && bulkOrgForm.Assertions!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkOrgForm.AssertionEmailsCount_Set }}</td></tr>
                                                                <tr><td>No Emails </td><td>: {{ bulkOrgForm.AssertionEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkOrgForm.AssertionEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Email on all" value="set"></v-radio>
                                                    <v-radio label="No Emails" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Path Changes?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has <b>NOT</b> changed.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex >
                                                <v-radio-group v-model="bulkOrgForm.PathChanges" @change="displayOrgBulkUpdateMessage=false" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkOrgForm.PathChangesCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkOrgForm.PathChangesCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkOrgForm.PathChangesMixedDisabled"></v-radio>
                                                    <v-radio label="Alert on all" value="set"></v-radio>
                                                    <v-radio label="No Alerts" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex >
                                                <v-radio-group v-model="bulkOrgForm.PathChangeEmails" @change="displayOrgBulkUpdateMessage=false"  :disabled="bulkOrgForm.PathChanges!='mixed' && bulkOrgForm.PathChanges!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkOrgForm.PathChangeEmailsCount_Set }}</td></tr>
                                                                <tr><td>Not emails </td><td>: {{ bulkOrgForm.PathChangeEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkOrgForm.PathChangeEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Email on all" value="set"></v-radio>
                                                    <v-radio label="No Emails" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>First Seens?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where there was no origin (ownership) ASN from the given peer i.e. the system has not seen a route to this prefix from the given peer.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex >
                                                <v-radio-group v-model="bulkOrgForm.FirstSeens" label="Alerts" @change="displayOrgBulkUpdateMessage=false"  >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkOrgForm.FirstSeensCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkOrgForm.FirstSeensCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>
                                                    <v-radio label="Mixed" value="mixed" :disabled="bulkOrgForm.FirstSeensMixedDisabled"></v-radio>
                                                    <v-radio label="Set" value="set"></v-radio>
                                                    <v-radio label="Not Set" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex>
                                                <v-radio-group v-model="bulkOrgForm.FirstSeenEmails" @change="displayOrgBulkUpdateMessage=false"  label="Emails" :disabled="bulkOrgForm.FirstSeens!='mixed' && bulkOrgForm.FirstSeens!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkOrgForm.FirstSeenEmailsCount_Set }}</td></tr>
                                                                <tr><td>Not emails </td><td>: {{ bulkOrgForm.FirstSeenEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Mixed" value="mixed" :disabled="bulkOrgForm.FirstSeenEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Set" value="set"></v-radio>
                                                    <v-radio label="Not Set" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout align-center justify-center>
                                </v-layout>
                                <v-layout align-center justify-center>
                                    <v-flex xs12 md10 v-if="displayOrgBulkUpdateMessage">
                                        <br />
                                        <v-card class="justify-right" color="success">
                                            <h3> {{ bulkOrgMessage }} </h3>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-layout>





                    <v-layout justify-center align-center class="px-0 py-0">
                        <v-container>
                            <v-data-table  v-if="showOrgPrefs " 
                                :headers="contPrefixHeaders" 
                                :total-items="totalOrgResults"
                                :items="orgPrefixes" 
                                :key="id"
                                :footer-props="{ 
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    itemsPerPageOptions: rowsPerPageItems
                                }"
                                :rows-per-page-items="rowsPerPageItems" 
                                :pagination.sync="pagination_org"
                            >    
                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip top eager>
                                    <span :style="$store.state.textFormatting.main" slot="activator">
                                        {{ props.header.text }}
                                    </span>
                                    <span :style="$store.state.textFormatting.main">
                                        {{ props.header.ad_text }}
                                    </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td :style="$store.state.textFormatting.main"> {{props.item.hostname}} </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.ip_address }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> {{ props.item.asn }}</td>
                                        <!--<td :style="$store.state.textFormatting.main" class="text-xs-center"> <v-icon> {{ props.item.email_icon }} </v-icon> </td>-->
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> {{ props.item.impact_setting }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[0]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split[0]"> clear </v-icon>
                                            <span v-if="props.item.opf_split[0]">
                                                (
                                                <v-icon v-if="props.item.opf_split[3]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split[3]"> clear </v-icon>
                                                <v-icon v-if="props.item.opf_split_e[0]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[0]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[1]"> check </v-icon> 
                                            <v-icon v-if="!props.item.opf_split[1]"> clear </v-icon>
                                            <span v-if="props.item.opf_split[1]">
                                                (
                                                <v-icon v-if="props.item.opf_split_e[1]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[1]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[2]"> check </v-icon> 
                                            <v-icon v-if="!props.item.opf_split[2]"> clear </v-icon> 
                                            <span v-if="props.item.opf_split[2]">
                                                (
                                                <v-icon v-if="props.item.opf_split_e[2]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[2]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.description }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                            {{ props.item.notification_count }} 
                                            
                                            <v-icon small color="success" v-if="!props.item.noti_show && props.item.notification_count > 0" @click="viewNotif(props.item)"> add </v-icon> 
                                        
                                            <v-icon color="success" v-if="props.item.noti_show && props.item.notification_count > 0" small @click="viewNotif(props.item)"> remove </v-icon> 
                                            
                                            <small v-if="props.item.noti_show">
                                                <br />
                                                {{ props.item.notification_str }}
                                            </small>

                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                            <v-tooltip top eager close-delay=100>
                                                <template  v-slot:activator="{ on }">
                                                    <v-icon v-on="on" small class="mr-2" @click="clickPrefix(props.item.hostname, 
                                                    props.item.ipv4_address, props.item.ipv6_address, props.item.asn,
                                                    props.item.description, 'organisation', props.item.send_emails, props.item.impact_setting, props.item.ip_address, props.item.opf_split, props.item.opf_split_e)"> edit </v-icon>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Edit Prefix</span>
                                            </v-tooltip>
                                            
                                            <v-tooltip top eager close-delay=100>
                                                <template  v-slot:activator="{ on }">
                                                    <v-icon v-on="on" small class="mr-2" @click="prepRemoveControlledPrefix(props.item.hostname, 
                                                    props.item.ipv4_address, props.item.ipv6_address, props.item.asn, 'organisation')"> delete </v-icon>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Remove Prefix</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                    
                                </template>
                                <template slot="no-data">
                                    <v-alert :value="true" color="success" icon="warning">
                                    No results found
                                    </v-alert>
                                </template>
                            </v-data-table>

                        </v-container>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>

        <br />

        <v-layout wrap justify-center>
            <v-flex xs12 md10>
                <v-card>
                    <v-toolbar dark flat color="secondary">
                        <v-toolbar-title @click="showUserPrefs=!showUserPrefs"> {{username}}'s Restricted Prefixes</v-toolbar-title>
                        <v-progress-circular v-if="loading2" indeterminate color="white"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <v-flex shrink align-center justify-center>
                            <br />
                            <v-switch v-model="showUserFilters" @change="UserFiltersChange()">
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main"><b>Show/Hide Filters</b></div>
                                </template>
                            </v-switch>
                        </v-flex>
                        <v-flex shrink align-center justify-center>
                            <br />
                            <v-switch v-model="showAdvanced" @change="advancedChange()">
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main"><b>Advanced settings</b></div>
                                </template>
                            </v-switch>
                        </v-flex>
                        <v-btn 
                            small 
                            dark 
                            color="success"
                            @click="ClickPrepareDownload('user')"
                            >
                            <v-icon>save_alt</v-icon>User Prefixes
                        </v-btn>

                        <v-btn @click="clickPrefix('Click here to add prefix', '', '', 0, '', 'user', '', '', '', '')" color="success" > Add prefix <v-icon>add</v-icon></v-btn>
                        <info>
                            <template slot>
                                Add/Change/Delete controlled prefixes to your user
                            </template>
                            <template slot="body">
                                The alerting mechanism works in the following way: <br />
                                
                                <p> <h2> SIMPLE ALERTING (no advanced settings) </h2> </p>
                                <ul>
                                    <li> The user defines a prefix, give it a name (for housekeeping), and will be alerted upon ownership assertions involing this prefix i.e. where the ownership has changed </li>
                                    <li> You will <b>not receive emails</b> and alerts are created <b>regardless of hijack and impact scores</b> created by the system. Alerts will come through with an Impact score overriden to <b>80.</b></li> 
                                </ul>

                                <p> <h2> ADVANCED ALERTING (advanced settings) </h2> </p>
                                <ul>
                                    <li> User can specify <b>which event types to be alerted upon</b>, of which there are 3 in total: 
                                        <ul>
                                            <li><b>Ownership Assertions</b></li>
                                            <li><b>Path Changes</b></li>
                                            <li><b>First Seens</b></li>
                                        </ul>
                                        There are descriptions of each of these in <b>hover over panels throughout the page - hover your cursor where you see any of these terms</b>
                                    </li>
                                    <li> The user can also decide whether to receive emails from these alerts, again split out by the event type </li>
                                    <li> When an alert occurs with emails turned on, an initial email is sent out, alerting the user of the alert beginning. </li>
                                    <li> You can choose to associate an ASN to the prefix, purely for housekeeping</li>
                                    <li> The user can set the <b>Impact score</b> that alerts will receive for the given prefix</li>                                    
                                </ul>
                                <br>
                                <p>
                                    <b> Any alerts triggered by user prefixes will appear in your view of BGP Spotlight, and will be invisible to 
                                        other users in your organisation.
                                    </b>
                                </p>
                                <p><h2> FILTERS and BULK CHANGES </h2></p>
                                <ul>
                                    <li> Where a user wants to limit what is displayed or carry out bulk changes on their entries, the <b>SHOW/HIDE FILTERS</b> option opens an initial view that shows FILTER options where the IP Address or Name can be used to filter the display. (<b>The filter results show "beginning with" matches.</b>)</li>
                                    <li> Where bulk operations are required, such as changes or deletions, the <b>SHOW/HIDE BULK OPTIONS</b> allows changes to be made against all of the entries or just the filtered set. Additionally, entries can be deleted in the same way.</li>
                                    <li> NOTE: The DOWNLOAD option will download the filtered records only. i.e. with no filter, all entries will be downloaded. Similarly, the DELETE option will delete the filtered entries only.</li>
                                </ul>
                            </template>
                        </info>

                    </v-toolbar>
                    <v-layout v-if="showUserFilters" justify-center align-center class="px-0 py-0">

                            <v-form ref="UserFilterForm" v-model="valid" lazy-validation>
                                <v-layout wrap justify-center row>
                                    <v-flex xs3 class="px-2">
                                        <v-text-field 
                                            :style="$store.state.textFormatting.main" 
                                            v-model="UserFilterForm.name" 
                                            label="Filter by Name"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 class="px-2">
                                        <v-text-field 
                                            :style="$store.state.textFormatting.main" 
                                            v-model="UserFilterForm.ip_address" 
                                            label="Filter by IP Prefix"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 class="px-2">
                                        <v-btn
                                        :disabled="!valid"
                                        color="success"
                                        @click="ApplyUserFilter"
                                        >
                                        Apply
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs3 class="px-2" align-center justify-center>
                                        <v-switch v-model="showUserBulkUpdate">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main"><b>Show/Hide Bulk Update Options</b></div>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                    </v-layout>

                    <v-layout v-if="showUserBulkUpdate && showUserFilters" justify-center align-center class="xs-12 px-0 py-0">
                        <v-container>

                            <v-form ref="UserBulkForm">
                                <v-layout wrap justify-center row class="px-0 py-0">
                                    <v-flex xs2 align-center justify-center>
                                        <v-radio-group v-model="bulkUserForm.ImpactSetting" label="Impact Setting">
                                            <v-radio label="No Change" value="mixed"></v-radio>
                                            <v-radio label="Set Value" value="set"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs4 class="px-2">
                                        <v-subheader class="pl-0">Impact Score Value (Current range :  {{ bulkUserForm.ImpactMin }} to {{ bulkUserForm.ImpactMax }})</v-subheader>
                                        <v-slider :disabled="this.bulkUserForm.ImpactSetting=='mixed'" v-model="bulkUserForm.ImpactValue" thumb-label="always" min="0" max="99"></v-slider>
                                    </v-flex>
                                    <v-flex xs6 class="px-2" align-center >
                                        <v-layout wrap justify-end row class="px-0 py-0">
                                            <p>Apply changes to Filtererd Rules: ( {{ totalUserResults }} entries )
                                            <v-btn
                                            :disabled="!valid"
                                            color="success"
                                            @click="showBulkUpdateUser=true;"
                                            >Apply Changes</v-btn></p>
                                        </v-layout> 
                                        <v-layout wrap justify-end row class="px-0 py-0">
                                            <p>DELETE Filtererd Rules: ( {{ totalUserResults }} entries )
                                            <v-btn
                                            :disabled="!valid"
                                            color="red"
                                            @click="showBulkDeleteUser=true;"
                                            >DELETE FILTERED</v-btn></p>
                                        </v-layout> 
                                    </v-flex>

                                </v-layout>
                                <v-layout wrap justify-center row class="px-0 py-0">
                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Ownership Assertions?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has changed.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-radio-group v-model="bulkUserForm.Assertions"  @change="displayUserBulkUpdateMessage=false" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkUserForm.AssertionsCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkUserForm.AssertionsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay mixed" value="mixed" :disabled="bulkUserForm.AssertionsMixedDisabled"></v-radio>
                                                    <v-radio label="Alert on all" value="set"></v-radio>
                                                    <v-radio label="No Alerts" value="notset">
                                                    </v-radio>
                                                </v-radio-group>
                                                <v-radio-group v-model="bulkUserForm.IntraOrg" @change="displayUserBulkUpdateMessage=false" :disabled="bulkUserForm.Assertions!='mixed' && bulkUserForm.Assertions!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Intra-Org Assertions</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Excluded </td><td>: {{ bulkUserForm.IntraOrgCount_Set }}</td></tr>
                                                                <tr><td>Included </td><td>: {{ bulkUserForm.IntraOrgCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay mixed" value="mixed" :disabled="bulkUserForm.IntraOrgMixedDisabled"></v-radio>
                                                    <v-radio label="Exclude all" value="set"></v-radio>
                                                    <v-radio label="Include all" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex >
                                                <v-radio-group v-model="bulkUserForm.AssertionEmails" @change="displayUserBulkUpdateMessage=false" :disabled="bulkUserForm.Assertions!='mixed' && bulkUserForm.Assertions!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkUserForm.AssertionEmailsCount_Set }}</td></tr>
                                                                <tr><td>No Emails </td><td>: {{ bulkUserForm.AssertionEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkUserForm.AssertionEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Email on all" value="set"></v-radio>
                                                    <v-radio label="No Emails" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Path Changes?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has <b>NOT</b> changed.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex >
                                                <v-radio-group v-model="bulkUserForm.PathChanges"  @change="displayUserBulkUpdateMessage=false">
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkUserForm.PathChangesCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkUserForm.PathChangesCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkUserForm.PathChangesMixedDisabled"></v-radio>
                                                    <v-radio label="Alert on all" value="set"></v-radio>
                                                    <v-radio label="No Alerts" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex >
                                                <v-radio-group v-model="bulkUserForm.PathChangeEmails" @change="displayUserBulkUpdateMessage=false" :disabled="bulkUserForm.PathChanges!='mixed' && bulkUserForm.PathChanges!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkUserForm.PathChangeEmailsCount_Set }}</td></tr>
                                                                <tr><td>Not emails </td><td>: {{ bulkUserForm.PathChangeEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Stay Mixed" value="mixed" :disabled="bulkUserForm.PathChangeEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Email on all" value="set"></v-radio>
                                                    <v-radio label="No Emails" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs-4 align-center justify-center>
                                        <v-layout>
                                            <v-tooltip top eager close-delay=500 >
                                                <template  v-slot:activator="{ on }">
                                                    <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>First Seens?</b></div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Alerts where there was no origin (ownership) ASN from the given peer i.e. the system has not seen a route to this prefix from the given peer.</span>
                                            </v-tooltip>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex >
                                                <v-radio-group v-model="bulkUserForm.FirstSeens" label="Alerts" @change="displayUserBulkUpdateMessage=false" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Alerts</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Alerting </td><td>: {{ bulkUserForm.FirstSeensCount_Set }}</td></tr>
                                                                <tr><td>No Alerts </td><td>: {{ bulkUserForm.FirstSeensCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>
                                                    <v-radio label="Mixed" value="mixed" :disabled="bulkUserForm.FirstSeensMixedDisabled"></v-radio>
                                                    <v-radio label="Set" value="set"></v-radio>
                                                    <v-radio label="Not Set" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex>
                                                <v-radio-group v-model="bulkUserForm.FirstSeenEmails" @change="displayUserBulkUpdateMessage=false" label="Emails" :disabled="bulkUserForm.FirstSeens!='mixed' && bulkUserForm.FirstSeens!='set'" >
                                                    <template v-slot:label>
                                                        <table>
                                                            <thead><tr><th colspan="2">Emails</th></tr></thead>
                                                            <tbody>
                                                                <tr><td>Emailing </td><td>: {{ bulkUserForm.FirstSeenEmailsCount_Set }}</td></tr>
                                                                <tr><td>Not emails </td><td>: {{ bulkUserForm.FirstSeenEmailsCount_NotSet }}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </template>                                                        
                                                    <v-radio label="Mixed" value="mixed" :disabled="bulkUserForm.FirstSeenEmailsMixedDisabled"></v-radio>
                                                    <v-radio label="Set" value="set"></v-radio>
                                                    <v-radio label="Not Set" value="notset"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout align-center justify-center>
                                    <v-flex xs12 md10 v-if="displayUserBulkUpdateMessage">
                                        <br />
                                        <v-card class="justify-right" color="success">
                                            <h3> {{ bulkUserMessage }} </h3>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-layout>
                    <v-layout align-center justify-center>
                        <v-container>
                            <v-data-table v-if="showUserPrefs "
                                :headers="contPrefixHeaders" 
                                :items="userPrefixes"
                                :total-items="totalUserResults"
                                :key="id"
                                :footer-props="{ 
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    itemsPerPageOptions: rowsPerPageItems
                                }"
                                :rows-per-page-items="rowsPerPageItems" 
                                :pagination.sync="pagination_user"
                            >    
                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip top eager>
                                    <span :style="$store.state.textFormatting.main" slot="activator">
                                        {{ props.header.text }}
                                    </span>
                                    <span :style="$store.state.textFormatting.main">
                                        {{ props.header.ad_text }}
                                    </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td :style="$store.state.textFormatting.main"> {{props.item.hostname}} </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.ip_address }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> {{ props.item.asn }}</td>
                                        <!--<td :style="$store.state.textFormatting.main" class="text-xs-center"> <v-icon> {{ props.item.email_icon }} </v-icon> </td>-->
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> {{ props.item.impact_setting }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[0]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split[0]"> clear </v-icon>
                                            <span v-if="props.item.opf_split[0]">
                                                (
                                                <v-icon v-if="props.item.opf_split[3]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split[3]"> clear </v-icon>
                                                <v-icon v-if="props.item.opf_split_e[0]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[0]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[1]"> check </v-icon> 
                                            <v-icon v-if="!props.item.opf_split[1]"> clear </v-icon>
                                            <span v-if="props.item.opf_split[1]">
                                                (
                                                <v-icon v-if="props.item.opf_split_e[1]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[1]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                            <v-icon v-if="props.item.opf_split[2]"> check </v-icon> 
                                            <v-icon v-if="!props.item.opf_split[2]"> clear </v-icon> 
                                            <span v-if="props.item.opf_split[2]">
                                                (
                                                <v-icon v-if="props.item.opf_split_e[2]"> check </v-icon>
                                                <v-icon v-if="!props.item.opf_split_e[2]"> clear </v-icon>
                                                )
                                            </span>
                                        </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.description }}</td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                            {{ props.item.notification_count }} 
                                            
                                            <v-icon small color="success" v-if="!props.item.noti_show && props.item.notification_count > 0" @click="viewNotif(props.item)"> add </v-icon> 
                                        
                                            <v-icon color="success" v-if="props.item.noti_show && props.item.notification_count > 0" small @click="viewNotif(props.item)"> remove </v-icon> 
                                            
                                            <small v-if="props.item.noti_show">
                                                <br />
                                                {{ props.item.notification_str }}
                                            </small>

                                            </td>
                                        <td :style="$store.state.textFormatting.main" class="text-xs-center">

                                            <v-tooltip top eager close-delay=100>
                                                <template  v-slot:activator="{ on }">
                                                    <v-icon v-on="on" small class="mr-2" @click="clickPrefix(props.item.hostname, 
                                                    props.item.ipv4_address, props.item.ipv6_address, props.item.asn,
                                                    props.item.description, 'user', props.item.send_emails, props.item.impact_setting, props.item.ip_address, props.item.opf_split, props.item.opf_split_e)"> edit </v-icon>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Edit Prefix</span>
                                            </v-tooltip>
                                            
                                            <v-tooltip top eager close-delay=100>
                                                <template  v-slot:activator="{ on }">
                                                    <v-icon v-on="on" small class="mr-2" @click="prepRemoveControlledPrefix(props.item.hostname, 
                                                    props.item.ipv4_address, props.item.ipv6_address, props.item.asn, 'user')"> delete </v-icon>
                                                </template>
                                                <span :style="$store.state.textFormatting.main">Remove Prefix</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                    
                                </template>
                                <template slot="no-data">
                                    <v-alert :value="true" color="success" icon="warning">
                                    No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-container>

                    </v-layout>
                    <!-- <v-layout align-right justify-center v-if="userPrefixes.length > 1">
                        <v-spacer />
                        <v-flex shrink class="py-2 px-2">
                            <v-btn @click="showPurge=true" color="red">Delete All Prefixes</v-btn>
                        </v-flex>
                    </v-layout> -->

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout wrap justify-center>
            <v-flex xs12 md10 v-if="showEdit">
                <br />
                <v-card>
                    <v-toolbar flat dark color="primary">
                        <v-toolbar-title v-if="edType == 'Add'">Add restricted prefix to your {{ addType }} </v-toolbar-title>
                        <v-toolbar-title v-if="edType == 'Edit'">Edit selected restricted prefix </v-toolbar-title>
                        

                        <v-spacer></v-spacer>

                        
                        <!--<v-btn color="#d53bc9" class="mr-4" @click="batchOpen" v-if="edType == 'Add'"> Batch Prefix Add </v-btn>-->
                        <v-btn color="#3F8993" class="mr-4" @click="csvOpen" v-if="edType == 'Add'"> CSV Prefix Add </v-btn>
                        <v-btn color="success" class="mr-4" @click="editControlledPrefix" v-if="edType == 'Edit'" :disabled="!valid"> Submit </v-btn>
                        <v-btn color="success" class="mr-4" @click="editControlledPrefix" v-if="edType == 'Add'" :disabled="!valid"> Submit </v-btn>
                        <!-- <v-btn color="red" class="mr-4" @click="prepRemoveControlledPrefix" v-if="edType == 'Edit'"> Remove Prefix </v-btn> !-->
                        <v-btn class="mx-2" fab small color="blue" @click="shrinkEditWindow">
                            <h3>-</h3>
                        </v-btn>

                    </v-toolbar>

                    <v-container fluid>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-layout column>
                                    <v-layout wrap justify-center row>
                                        <v-flex xs6 class="px-2">
                                            <v-text-field v-model="form.hostname" :rules="hostRules" label="Host Name" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs6 class="px-2">
                                            <v-text-field v-model="form.ip" :rules="vbothrules" :counter="43" label="Prefix (IPv4 / IPv6)" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    
                                    <v-layout>
                                        <v-flex>
                                            <v-textarea v-model="form.description" :rules="descRules" name="comments" label="Description" hint="A description of the prefix's purpose i.e DNS"></v-textarea>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout>
                                        <v-flex shrink align-center justify-center>
                                            <v-switch v-model="showAdvanced" @change="advancedChange()">
                                                <template v-slot:label>
                                                    <div :style="$store.state.textFormatting.main"><b>Advanced settings</b></div>
                                                </template>
                                            </v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <br v-if="showAdvanced" />
                                    <v-divider v-if="showAdvanced" />
                                    <br v-if="showAdvanced" />

                                    <v-layout v-if="showAdvanced" align-center justify-center>
                                        <v-flex xs3 class="px-2">
                                            <v-select v-model="form.asn" v-if="addType=='organisation'" :items="asn" :rules="asnRules" label="Associated ASN (optional)"></v-select>
                                            <v-select v-model="form.asn" v-if="addType=='user'" :items="userasn" :rules="asnRules" label="Associated ASN (optional)"></v-select>
                                        </v-flex>
                                        <!--<v-flex xs3>
                                            <v-tooltip top eager>
                                            <span :style="$store.state.textFormatting.main" slot="activator">
                                                <v-switch v-model="form.send_emails" label="Emails?"></v-switch>
                                            </span>
                                            <span :style="$store.state.textFormatting.main">
                                                Whether you shall receive emails with alerts from this host
                                            </span>
                                            </v-tooltip>
                                            
                                        </v-flex>-->
                                        <v-flex xs6 class="px-2">
                                            <v-subheader class="pl-0">Impact Score Setting</v-subheader>
                                            <v-slider v-model="form.impact" thumb-label="always" min="0" max="99"></v-slider>
                                        </v-flex>
                                    </v-layout>
                                    
                                    
                                    <v-layout v-if="showAdvanced">

                                        <v-flex align-center justify-center>
                                            <v-layout>
                                                <v-tooltip top eager close-delay=500 >
                                                    <template  v-slot:activator="{ on }">
                                                        <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Ownership Assertions?</b></div>
                                                    </template>
                                                    <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has changed.</span>
                                                </v-tooltip>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split[0]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Alerts</div>
                                                        </template> 
                                                    </v-switch>
                                                    <v-switch v-model="form.opf_split[3]" :disabled="!form.opf_split[0]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">IntraOrg</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split_e[0]" :disabled="!form.opf_split[0]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Emails</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex align-center justify-center>
                                            <v-layout>
                                                <v-tooltip top eager close-delay=500 >
                                                    <template  v-slot:activator="{ on }">
                                                        <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>Path Changes?</b></div>
                                                    </template>
                                                    <span :style="$store.state.textFormatting.main">Alerts where the origin (ownership) ASN has <b>NOT</b> changed.</span>
                                                </v-tooltip>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split[1]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Alerts</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split_e[1]" :disabled="!form.opf_split[1]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Emails</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex align-center justify-center>
                                            <v-layout>
                                                <v-tooltip top eager close-delay=500 >
                                                    <template  v-slot:activator="{ on }">
                                                        <div slot="activator" v-on="on" :style="$store.state.textFormatting.main"><b>First Seens?</b></div>
                                                    </template>
                                                    <span :style="$store.state.textFormatting.main">Alerts where there was no origin (ownership) ASN from the given peer i.e. the system has not seen a route to this prefix from the given peer.</span>
                                                </v-tooltip>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split[2]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Alerts</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-switch v-model="form.opf_split_e[2]" :disabled="!form.opf_split[2]">
                                                        <template v-slot:label>
                                                            <div :style="$store.state.textFormatting.main">Emails</div>
                                                        </template> 
                                                    </v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                    </v-layout>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-flex>

            <v-dialog v-model="showBulkUpdateUser" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Update Filtered User Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to update all of your user restricted prefixes for the selected filter? This is not reversible</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="doBulkUpdateUser"> Yes, update</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showBulkUpdateUser=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showBulkUpdateOrg" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Update Filtered Organisation Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to update all of your organisation restricted prefixes for the selected filter? This is not reversible</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="doBulkUpdateOrg"> Yes, update</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showBulkUpdateOrg=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showBulkDeleteOrg" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Delete Filtered Organisation Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to DELETE FILTERED restricted prefixes? This is not reversible</h3>
                        <h3> It is highly recommended to download a CSV of the prefixes prior to deletion</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="doBulkDeleteOrg"> Yes, delete</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showBulkDeleteOrg=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showBulkDeleteUser" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Delete Filtered User Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to DELETE FILTERED restricted prefixes? This is not reversible</h3>
                        <h3> It is highly recommended to download a CSV of the prefixes prior to deletion</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="doBulkDeleteUser"> Yes, delete</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showBulkDeleteUser=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showPurge" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Remove all user prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to delete ALL restricted prefixes? This is not reversible</h3>
                        <h3> It is highly recommended to download a CSV of the prefixes prior to deletion</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :disabled="purge_loading" class="green" dark @click="purgePrefixes"> Yes, delete</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showPurge=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showAreYouSure" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Remove {{ selectedPrefix.hostname }} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3> Are you sure you want to delete restricted prefix with hostname: {{ selectedPrefix.hostname }}?</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="removeControlledPrefix"> Yes, delete</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showAreYouSure=false"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="userDownload" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Download User Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3 v-if = "!userDownloadReady"> Preparing your download... please wait</h3>
                        <p v-if = "!userDownloadReady"> {{ this.userCount }} of {{this.totalUserResults}} <v-progress-circular indeterminate color="secondary"></v-progress-circular></p>
                        <v-progress-linear v-if = "!userDownloadReady" v-model="userDownloadProgress"></v-progress-linear>
                        <h3 v-if = "userDownloadReady"> Your download of {{this.totalUserResults}} records is ready. Click the button to download</h3>
                        <downloadcsv
                            v-if = "userDownloadReady"
                            class   = "btn btn-default"
                            :data   = "user_download_prefixes"
                            name = "userPrefixes.csv"
                            >
                            <v-tooltip top eager color="primary" id="exit-app">
                                <template v-slot:activator="{ on }">
                                    <v-btn small dark v-on="on" color="success"> <v-icon>save_alt</v-icon> User Prefixes </v-btn>
                                </template>
                                <span :style="$store.state.textFormatting.main">CSV of user prefixes</span>
                            </v-tooltip>        
                        </downloadcsv>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="userDownloadClose"> Close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="orgDownload" width="500">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Download Organisation Prefixes </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3 v-if = "!orgDownloadReady"> Preparing your download... please wait</h3>
                        <p v-if = "!orgDownloadReady"> {{ this.orgCount }} of {{this.totalOrgResults}} <v-progress-circular indeterminate color="secondary"></v-progress-circular></p>
                        <v-progress-linear v-if = "!orgDownloadReady" v-model="orgDownloadProgress"></v-progress-linear>
                        <h3 v-if = "orgDownloadReady"> Your download of {{this.totalOrgResults}} records is ready. Click the button to download</h3>
                        <downloadcsv
                            v-if = "orgDownloadReady"
                            class   = "btn btn-default"
                            :data   = "org_download_prefixes"
                            name = "orgPrefixes.csv"
                            >
                            <v-tooltip top eager color="primary" id="exit-app">
                                <template v-slot:activator="{ on }">
                                    <v-btn small dark v-on="on" color="success"> <v-icon>save_alt</v-icon> Organisation Prefixes </v-btn>
                                </template>
                                <span :style="$store.state.textFormatting.main">CSV of Organisation prefixes</span>
                            </v-tooltip>        
                        </downloadcsv>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="orgDownloadClose"> Close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-dialog v-model="showBatch" width="800" persistent>
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> Batch add prefixes </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <info>
                        <template>
                            Add multiple restricted prefixes
                        </template>
                        <template slot="body">
                            <p> Select an ASN to associate all the given prefixes with (this has no impact on the analytics, it's purely for book keeping) </p>
                            <p> Pick a hostname group, where each entry to the table will be called [HOSTNAME] #1, [HOSTNAME] #2 etc. </p>
                            <p> Input IPv4 prefixes on the left, and IPv6 prefixes on the right. These will be added to your list of restricted prefixes </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card justify-center>
                    <br />
                    <v-data-table :headers="batchHeaders" :items="batchPrefixes" :key="id" :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2">
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td :style="$store.state.textFormatting.main"> <v-text-field v-model="props.item.ip" :rules="vbothrules_b"> </v-text-field> </td>
                                <td :style="$store.state.textFormatting.main"> {{ props.item.msg }} </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn @click="batchGrow" color="success"> <v-icon> add </v-icon> </v-btn>
                    </v-layout>
                    <v-form ref="form2" v-model="valid2" lazy-validation>
                        <v-flex>                        
                            <v-layout>
                                <v-flex xs1> </v-flex>
                                <v-flex xs6>
                                    <v-select v-model="batchASN" v-if="addType=='organisation'" :items="asn" :rules="asnRules" label="Associated ASN"> </v-select>
                                    <v-select v-model="batchASN" v-if="addType=='user'" :items="userasn" :rules="asnRules" label="Associated ASN"> </v-select>
                                </v-flex>
                                <v-flex xs1> </v-flex>
                                <v-flex xs6>
                                    <v-text-field v-model="batchHost" :rules="hostRules" label="Hostname group" required> </v-text-field>
                                </v-flex>
                                <v-flex xs1> </v-flex>
                            
                            </v-layout>
                        </v-flex>
                        <v-flex justify-center align-center>
                            <v-layout justify-center align-center>
                                <v-flex xs6 justify-center align-center>
                                    <v-subheader class="pl-0">Impact Score Setting</v-subheader>
                                    <v-slider v-model="batchImpact" thumb-label="always" min="0" max="99"></v-slider>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        
                        <br />
                        <v-layout>
                            <v-btn color="red" class="mr-4" @click="batchClose"> Cancel <v-icon> mdi-cancel </v-icon> </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="success" class="mr-4" @click="batchSubmit" :disabled="!valid2"> Submit <v-icon>mdi-checkbox-marked-circle</v-icon>  </v-btn>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-flex xs12 md10 v-if="displayMessage">
                <br />
                <v-card class="justify-right" color="success">
                    <h3> {{ message }} </h3>
                </v-card>
            </v-flex>

            <v-dialog v-model="showCSV" persistent :width="$store.state.textFormatting.dialog.b_width">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title> CSV Import Prefixes ({{ addType }}) </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "csvTemplate"
                        name = "csvTemplate.csv">
                        <v-tooltip top eager color="primary" id="exit-app">
                            <template v-slot:activator="{ on }">
                                <v-btn small dark v-on="on" color="success"> <v-icon>save_alt</v-icon> Template </v-btn>
                            </template>
                            <span :style="$store.state.textFormatting.main">CSV Template for prefix entry</span>
                        </v-tooltip>        
                    </downloadcsv>
                    <info>
                        <template>
                            Add multiple restricted prefixes from CSV
                        </template>
                        <template slot="body">
                            <p> Download template CSV file </p>
                            <p> Enter your prefixes into said file, then save (as CSV) </p>
                            <p> Press the 'choose file' button to upload the CSV </p>
                            <p> Check the entries look correct in the table, then click submit </p>
                            <br />
                            <p> <b> NOTE: </b> Please enter the <b> 'emails' </b> setting as any of:
                                <ul>
                                    <li> TRUE </li>
                                    <li> true </li>
                                    <li> Y </li>
                                    <li> y </li>
                                    <li> 1 </li>
                                </ul>
                                (for a 'yes' setting to emails). Anything else will default to 'no'. </p>
                            <p> <b> NOTE: </b> Prefixes will validate on CSV import, and will display errors if input incorrectly. Any prefix without a CIDR will default to (/32 or /128) for (IPv4 or IPv6) respectively. </p>
                            <p> <b> NOTE: </b> Non-integer ASNs will be set to 0, non-integer impact scores will be set to 80 </p>
                            <p> <b> NOTE: </b> Quotation marks in hostnames and descriptions will be removed </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card justify-center align-center>
                
                    <br />
                    <v-flex justify-center align-center class="text-xs-center">
                        <input type="file" id="csv_file" name="csv_file" class="form-controll" @change="loadCSV($event)">
                    </v-flex>
                    <br />
                    <v-flex>
                        <v-data-table :headers="csvHeaders" v-if="showCSVTable" :items="parse_csv" :key="id" :rows-per-page-items="rowsPerPageItems3" :pagination.sync="pagination3">
                            <template slot="headerCell" slot-scope="props">
                                <v-tooltip top eager>
                                <span :style="$store.state.textFormatting.main" slot="activator">
                                    {{ props.header.text }}
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.hostname }} </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.ip_prefix }}</td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.asn }} </td>
                                    <!--<td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.emails }} </td>-->
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.impact_setting }} </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                        <v-icon v-if="props.item.opf_split[0]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split[0]"> clear </v-icon>
                                        <span v-if="props.item.opf_split[0]">
                                            (
                                            <v-icon v-if="props.item.opf_split[3]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split[3]"> clear </v-icon>
                                            <v-icon v-if="props.item.opf_split_e[0]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split_e[0]"> clear </v-icon>
                                            )
                                        </span>
                                    </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                        <v-icon v-if="props.item.opf_split[1]"> check </v-icon> 
                                        <v-icon v-if="!props.item.opf_split[1]"> clear </v-icon>
                                        <span v-if="props.item.opf_split[1]">
                                            (
                                            <v-icon v-if="props.item.opf_split_e[1]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split_e[1]"> clear </v-icon>
                                            )
                                        </span>
                                    </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="showAdvanced"> 
                                        <v-icon v-if="props.item.opf_split[2]"> check </v-icon> 
                                        <v-icon v-if="!props.item.opf_split[2]"> clear </v-icon> 
                                        <span v-if="props.item.opf_split[2]">
                                            (
                                            <v-icon v-if="props.item.opf_split_e[2]"> check </v-icon>
                                            <v-icon v-if="!props.item.opf_split_e[2]"> clear </v-icon>
                                            )
                                        </span>
                                    </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.description }} </td>
                                    <td :style="$store.state.textFormatting.main" class="text-xs-center" v-if="props.item.msg"> {{ props.item.msg }} </td>

                                </tr>
                            </template>
                            <template slot="no-data">
                                <v-alert :value="true" color="success" icon="warning">
                                    Choose file to populate table
                                </v-alert>
                            </template>

                        </v-data-table>
                    </v-flex>
                    <v-layout align-center justify-center>
                        <v-flex v-if="csvErr" class="text-xs-center" xs10>
                            <v-card color="success">
                                <h4> {{ csvErr }} </h4>                                
                            </v-card>
                            <br />
                        </v-flex>
                    </v-layout>

                    <v-layout align-center justify-center>
                        <v-flex v-if="csvErr" class="text-xs-center" xs10>
                            <v-progress-linear
                                v-model="uploadValue"
                                :active="showProgress"
                                :indeterminate="indeterminate"
                            >
                            </v-progress-linear>
                            <h4 v-if="showProgress"> {{ runningTotal }} entries processed. Estimated time remaining {{ timeLeft }} (minutes:seconds)</h4>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-btn v-if="!uploadcompleted" color="red" class="mr-4" @click="csvCancel"> Cancel <v-icon> mdi-cancel </v-icon> </v-btn>
                        <v-btn v-if="uploadcompleted" color="red"  class="mr-4" @click="csvClose"> Close (completed) </v-btn>

                        <v-spacer></v-spacer>
                        <v-btn color="success" class="mr-4" @click="csvSubmit('organisation')" v-if="addType=='organisation'" :disabled="!valid3"> Submit <v-icon>mdi-checkbox-marked-circle</v-icon>  </v-btn>
                        <v-btn color="success" class="mr-4" @click="csvSubmit('user')" v-if="addType=='user'" :disabled="!valid3"> Submit <v-icon>mdi-checkbox-marked-circle</v-icon>  </v-btn>
                    </v-layout>
                </v-card>
            </v-dialog>

        </v-layout>
    </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import store from '../../store';
import info from '../../shared/operational/infopopout.vue';
import downloadcsv from 'vue-json-csv';
import { findParentComponentByName } from '../utils/findParent.js';
import OldRules from '../settings/oldRules.vue';

export default {
    name: 'prefixSettings',
    components: {
    info,
    downloadcsv,
    OldRules
},
    icons: {
        iconfont: 'mdi'
    },
    describe: 'This page allows Admins to add prefixes which they want to keep a keen eye on. For example there own domain name servers.',
    data() {
        return {
            showBulkDeleteOrg: false,
            showBulkDeleteUser: false,
            userCount:0,
            orgCount:0,
            userDownloadProgress: 0,
            userDownload: false,
            userDownloadReady: false,
            orgDownloadProgress: 0,
            orgDownload: false,
            orgDownloadReady: false,
            displayUserBulkUpdateMessage: false,
            displayOrgBulkUpdateMessage: false,
            bulkUserMessage: "Bulk Message",
            bulkOrgMessage: "Bulk Message",
            showOrgFilters: false,
            showUserFilters: false,
            showOrgBulkUpdate: false,
            showUserBulkUpdate: false,
            showBulkUpdateUser: false,
            showBulkUpdateOrg: false,
            OrgFilterForm: {
                name: "",
                ip_address: ""
            },
            UserFilterForm: {
                name: "",
                ip_address: ""
            },
            
            bulkUserForm: {
                ImpactSetting: 'notset',
                ImpactValue: 0,
                ImpactMax:0,
                ImpactMin:0,
                Assertions: 'notset',
                AssertionsCount_Set: 0,
                AssertionsCount_NotSet: 0,
                AssertionEmails: 'notset',
                AssertionEmailsCount_Set: 0,
                AssertionEmailsCount_NotSet: 0,
                AssertionsMixedDisabled: true,
                AssertionEmailMixedDisabled: true,

                IntraOrg: 'notset',
                IntraOrgMixedDisabled: true,
                IntraOrgCount_Set: 0,
                IntraOrgCount_NotSet: 0,

                PathChanges: 'notset',
                PathChangesCount_Set: 0,
                PathChangesCount_NotSet: 0,
                PathChangeEmails: 'notset',
                PathChangeEmailsCount_Set: 0,
                PathChangeEmailsCount_NotSet: 0,
                PathChangesMixedDisabled: true,
                PathChangeEmailsMixedDisabled: true,

                FirstSeens: 'notset',
                FirstSeensCount_Set: 0,
                FirstSeensCount_NotSet: 0,
                FirstSeenEmails: 'notset',
                FirstSeenEmailsCount_Set: 0,
                FirstSeenEmailsCount_NotSet: 0,
                FirstSeensMixedDisabled: true,
                FirstSeenEmailsMixedDisabled: true
            },
            bulkOrgForm: {
                ImpactSetting: 'notset',
                ImpactValue: 0,
                ImpactMax:0,
                ImpactMin:0,
                Assertions: 'notset',
                AssertionsCount_Set: 0,
                AssertionsCount_NotSet: 0,
                AssertionEmails: 'notset',
                AssertionEmailsCount_Set: 0,
                AssertionEmailsCount_NotSet: 0,
                AssertionsMixedDisabled: true,
                AssertionEmailMixedDisabled: true,

                IntraOrg: 'notset',
                IntraOrgMixedDisabled: true,
                IntraOrgCount_Set: 0,
                IntraOrgCount_NotSet: 0,

                PathChanges: 'notset',
                PathChangesCount_Set: 0,
                PathChangesCount_NotSet: 0,
                PathChangeEmails: 'notset',
                PathChangeEmailsCount_Set: 0,
                PathChangeEmailsCount_NotSet: 0,
                PathChangesMixedDisabled: true,
                PathChangeEmailsMixedDisabled: true,

                FirstSeens: 'notset',
                FirstSeensCount_Set: 0,
                FirstSeensCount_NotSet: 0,
                FirstSeenEmails: 'notset',
                FirstSeenEmailsCount_Set: 0,
                FirstSeenEmailsCount_NotSet: 0,
                FirstSeensMixedDisabled: true,
                FirstSeenEmailsMixedDisabled: true
            },
            timeLeft:"0:00",
            indeterminate:true,
            uploadcompleted:false,
            uploadTotal:0,
            uploadValue:0,
            runningTotal:0,
            showProgress:false,
            valid: false,
            valid2: false,
            showBatch: false,
            showAreYouSure: false,
            edType: 'Add',
            showEdit: false,
            selected: {
                v4: true,
                v6: true
            },
            hostRules: [ v => !!v || 'Hostname required', v => /^[^"]*$/.test(v) || 'No double-quotes allowed'],
            asnRules: [ v => /^\d+$/.test(v) || 'ASN must be a number'],
            descRules: [ v => /^[^"]*$/.test(v) || 'No double-quotes allowed' ],
            asn: [],
            userasn: [],
            rowsPerPageItems: [20, 30, 40, 50],
            pagination_user: {
                rowsPerPage: 10
            },
            pagination_org: {
                rowsPerPage: 10
            },
            pagination: {
                rowsPerPage: 10
            },
            rowsPerPageItems2: [100],
            pagination2: {
                rowsPerPage: 100
            },
            rowsPerPageItems3: [10, 20, 50, 100],
            pagination3: {
                rowsPerPage: 10
            },
            batchASN: null,
            batchHost: '',
            id: 1,
            organisation: '',
            username: '',
            vbothrules: [ v => !!v || 'A valid IPv4 / IPv6 address is required', v => /(^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([1-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$|^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))?$)/.test(v) || 'Address must be valid' ],
            vbothrules_b: [ v => /(^$|^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([1-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$|^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))?$)/.test(v) || 'Address must be valid' ],
            v4rules: [ v => !!v || 'A valid IPv4 address is required', v => /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))?$/.test(v) || 'Address must be valid' ],
            v6rules: [ v => !!v || 'A valid IPv6 address required', v => /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([1-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/.test(v) || 'Address must be valid' ],
            v4rules_b: [ v => /(^$|^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))?$)/.test(v) || 'Address must be valid' ],
            v6rules_b: [ v => /(^$|^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([1-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$)/.test(v) || 'Address must be valid' ],
            message: "",
            iconAdd: "zoom_out_map",
            loading: true,
            iconDel: "zoom_out_map",
            iconEdit: "zoom_out_map",
            sizeAdd: "xs12 md6 xl4",
            sizeDel: "xs12 md6 xl4",
            sizeEdit: "xs12 md6 xl4",
            contPrefixHeaders: [
                { text: 'Hostname', ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                { text: 'IP Address', ad_text:'IPv4/ IPv6 Address', value: 'ip_address', align:'centre'},
                { text: 'ASN', ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                { text: 'Emails?', ad_text:'Will you receive emails with alerts from this prefix', value: 'send_emails', align:'centre'},
                { text: 'Impact', ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                { text: 'Description', ad_text:'Optional description (for housekeeping)', align:'centre', sortable: false},
                { text: 'Alerts', ad_text:'Count of alerts over the last 24h for this host', value: 'notification_count', align:'centre'},
                { text: 'Actions', ad_text:'Edit / Delete', align:'centre', sortable: false}
                ],
            batchHeaders: [
                { text: 'IPv4 / IPv6 Prefixes', value:'ip', align:'centre', sortable: false},
                ],
            form: {
                hostname: '',
                ipv4: '',
                ipv6: '',
                ip: '',
                asn: '',
                description: '',
                send_emails: false,
                impact: 80,
                opf_split: [
                    true,
                    false,
                    false,
                    false,
                    false
                ]
            },
            selectedPrefix: {
                hostname: '',
                ipv4: '',
                ipv6: '',
                asn: '',
                description: ''
            },
            userPrefixes: [],
            orgPrefixes: [],
            displayMessage: false,
            asnInvTypes: {
                0: 'Regular',
                1: 'High Importance',
                2: 'Low Importance',
                3: 'Muted',
                4: 'Show All'
            },
            batchPrefixes: [
                {
                    ipv4: '',
                    ipv6: '',
                    msg: ''
                },
                {
                    ipv4: '',
                    ipv6: '',
                    msg: ''
                },
                {
                    ipv4: '',
                    ipv6: '',
                    msg: ''
                },
                {
                    ipv4: '',
                    ipv6: '',
                    msg: ''
                }
            ],
            batchImpact: 80,
            batchType: 'org',
            ipv4_err_msg: '',
            ipv6_err_msg: '',
            parse_header: [],
            parse_csv: [],
            sortOrders: {},
            sortKey: '',
            showCSV: false,
            valid3: false,
            csvHeaders: [
                { text: 'Hostname', ad_text:'A hostname you set for this set of prefixes', value: 'hostname', align:'centre'},
                { text: 'IPv4 / IPv6 Address', ad_text:'IPv4 / IPv6 Address', value: 'ip_prefix', align:'centre'},
                { text: 'ASN', ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                //{ text: 'Emails?', ad_text:'Will you receive emails with alerts from this prefix', value: 'send_emails', align:'centre'},
                { text: 'Impact', ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                { text: 'Own. Assertions?', ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                { text: 'Path Changes?', ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                { text: 'First Seens?', ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},    
                { text: 'Description', ad_text:'Optional description (for housekeeping)', align:'centre', sortable: false}
            ],
            correctHeaders: [
                'hostname',
                'ip_prefix',
                'asn',
                //'emails',
                'impact_setting',
                'own_assertions',
                'intra_org_assertions',
                'own_assertions_emails',
                'path_changes',
                'path_changes_emails',
                'first_seens',
                'first_seens_emails',
                'description'
            ],
            csvTemplate: [
                {
                    'hostname': 'string (no quotes)',
                    'ip_prefix': 'IPv4 / IPv6 prefix (will be appended with /32 or /128 rsp. if no CIDR)',
                    'asn': 'integer',
                    //'emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'impact_setting': '0-99',
                    'own_assertions': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'intra_org_assertions': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'own_assertions_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'path_changes': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'path_changes_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'first_seens': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'first_seens_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'description': 'string (no quotes)'
                }
            ],
            csvErr: null,
            addType: 'organisation',
            showCSVTable: true,
            showOrgPrefs: true,
            showUserPrefs: true,
            showAdvanced: false,
            showPurge: false,
            purge_loading: false,
            user_download_prefixes: [],
            organisation_download_prefixes: [],
            orgloading: false,
            userloading: false,
            totalUserResults: 0,
            totalOrgResults:0
        } 
    },
    beforeMount () {

        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
        
        try {
            this.organisation = this.$store.state.user.organisation;
            this.username = this.$store.state.user.username;
        } catch (err) {
            console.log(err)
            location.reload()
        }

        this.alertsPerASNandInfo('notuser');
        this.alertsPerASNandInfo('user');
        
        this.getControlledPrefixes(0,this.pagination_org.rowsPerPage);
        this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
        
        this.showAdvanced = this.$store.state.showSettings.advancedSettings;
        this.advancedChange();
    },
    mounted() {
    },
    methods: {
        purgePrefixes: async function () {
            this.purge_loading = true;
            try {
                var query = `
                    mutation purgePrefixes {
                        purgePrefixes (
                            p_user: "` + this.username + `",
                            p_organisation: "` + this.organisation + `"
                        ) {
                            response
                        }
                    }
                `;
                const  responseObj  = await API.graphql(graphqlOperation(query));
                this.purge_loading = false
                this.showPurge = false
                await this.sleep(1000);
                this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
            } catch (e) {
                console.log(e)
                this.purge_loading = false
                this.showPurge = false
                this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
            }
        },
        routeNewWindow: async function (input) {
            let routeData = this.$router.resolve({name: input});
            window.open(routeData.href, '_blank');
        },
        UserFiltersChange: async function () {
            if (!this.showUserFilters) {
                this.showUserBulkUpdate=false;
                this.UserFilterForm.ip_address='';
                this.UserFilterForm.name='';
                this.getData_user();
            }
        },
        OrgFiltersChange: async function () {
            if (!this.showOrgFilters) {
                this.showOrgBulkUpdate=false;
                this.OrgFilterForm.ip_address='';
                this.OrgFilterForm.name='';
                this.getData_org();
            }
        },
        advancedChange: async function () {
            if (this.showAdvanced) {
                this.contPrefixHeaders = [
                    { text: 'Hostname', ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                    { text: 'IP Address', ad_text:'IPv4/ IPv6 Address', value: 'ip_address', align:'centre'},
                    { text: 'ASN', ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                    //{ text: 'Emails?', ad_text:'Will you receive emails with alerts from this prefix', value: 'send_emails', align:'centre'},
                    { text: 'Impact', ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                    { text: 'Own. Assertions?', ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                    { text: 'Path Changes?', ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                    { text: 'First Seens?', ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                    { text: 'Description', ad_text:'Optional description (for housekeeping)', align:'centre', sortable: false},
                    { text: 'Alerts', ad_text:'Count of alerts over the last 24h for this host', value: 'notification_count', align:'centre'},
                    { text: 'Actions', ad_text:'Edit / Delete', align:'centre', sortable: false}
                ]
            } else {
                this.contPrefixHeaders = [
                    { text: 'Hostname', ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                    { text: 'IP Address', ad_text:'IPv4/ IPv6 Address', value: 'ip_address', align:'centre'},
                    //{ text: 'ASN', ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                    //{ text: 'Emails?', ad_text:'Will you receive emails with alerts from this prefix', value: 'send_emails', align:'centre'},
                    //{ text: 'Impact', ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                    { text: 'Description', ad_text:'Optional description (for housekeeping)', align:'centre', sortable: false},
                    { text: 'Alerts', ad_text:'Count of alerts over the last 24h for this host', value: 'notification_count', align:'centre'},
                    { text: 'Actions', ad_text:'Edit / Delete', align:'centre', sortable: false}
                ]
            }
        },
        csvOpen: function () {
            this.parse_header = []
            this.parse_csv = []
            this.valid3 = false
            this.csvErr = null
            this.showCSV = true
            this.uploadcompleted=false
            this.uploadValue=0
            this.showProgress=false;
            this.runningTotal=0;
            this.timeLeft="-:--";
        },
        csvClose: function () {
            this.showCSV = false
            this.showEdit=false;
        },
        csvCancel: function () {
            this.showCSV = false
            this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
            this.getControlledPrefixes(0,this.pagination_org.rowsPerPage);
            this.showEdit=false;
        },
        fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s},
        csvSubmit: async function (type) {

            var startTime=Math.floor(Date.now()/1000)
            var timeNow=startTime;
            var timeDiff=0;
            this.timeLeft="-:--"
            this.showProgress=true;
            this.indeterminate=false;
            this.valid3 = false
            if (type == 'user') {
                var p_user = this.$store.state.user.username
            } else {
                var p_user = 'whole_organisation'
            }
         //   console.log(this.parse_csv.length.toString() + " entries being submitted")
            var counter=0;
            var totalcount=0;
            var step = 1000;
            this.uploadcompleted=false
            this.uploadValue=0
            var affected=0;
            var updated=0;
            var csvarray=[];
            var remainingTime=0;
            var importRate=0;
            for ( var i = 0 ; i < this.parse_csv.length ; i++ ){
                var entry = this.parse_csv[i]
                if (entry.write == true && this.showCSV == true) { 
                    try{
                        if (entry.ip_prefix.includes(":")) {
                            csvarray.push(`{
                                p_hostname: "` + entry.hostname + `",
                                p_ipv4: "",
                                p_ipv6: "` + entry.ip_prefix + `",
                                p_asn: "` + entry.asn + `",
                                p_description: "` + entry.description + `",
                                organisation: "` + this.organisation + `",
                                p_user: "` + p_user + `",
                                p_send_emails: ` + entry.emails + `,
                                p_impact: ` + entry.impact_setting + `,
                                p_own_path_first: "` + entry.own_path_first + `",
                                p_emails_opf: "` + entry.emails_opf + `"
                                }`
                            )
                        } else {
                            csvarray.push(`{
                                p_hostname: "` + entry.hostname + `",
                                p_ipv4: "` + entry.ip_prefix + `",
                                p_ipv6: "",
                                p_asn: "` + entry.asn + `",
                                p_description: "` + entry.description + `",
                                organisation: "` + this.organisation + `",
                                p_user: "` + p_user + `",
                                p_send_emails: ` + entry.emails + `,
                                p_impact: ` + entry.impact_setting + `,
                                p_own_path_first: "` + entry.own_path_first + `",
                                p_emails_opf: "` + entry.emails_opf + `"

                            }`);
                        }
                        counter+=1;
                        totalcount+=1;
                        if (counter>=step) {
                            counter=0;
                            var edQuery = `mutation uploadControlledPrefixes { 
                                uploadControlledPrefixes(
                                    prefix_list: [`+csvarray.toString()+ `]
                                ) {
                                    affected
	                                changedRows
	                                message
                                }
                            }`;
                            csvarray=[];
                          //  console.log(edQuery);
                            const response = await API.graphql(graphqlOperation(edQuery));
                          //  console.log(response);
                            var responseMessage = response.data.uploadControlledPrefixes;
                            updated+=responseMessage.changedRows;
                            affected+=responseMessage.affected;
                          //  console.log(totalcount);
                            this.runningTotal=totalcount;
                          //  console.log("A="+affected.toString()+" U="+updated.toString());
                            this.uploadValue=Math.round((totalcount/this.uploadTotal)*100,0)
                            timeNow=Math.floor(Date.now()/1000)
                            timeDiff=timeNow-startTime;
                            importRate=totalcount/timeDiff;
                            remainingTime=Math.floor((this.uploadTotal-totalcount)/importRate)
                            this.timeLeft=this.fmtMSS(remainingTime);
                        }
                        this.showCSVTable = false
                        this.$nextTick(() => {
                        // Add the component back in
                        this.showCSVTable = true;
                        });

                    } catch (err) {
                        entry.msg = err
                        this.showCSVTable = false
                        this.$nextTick(() => {
                        // Add the component back in
                        this.showCSVTable = true;
                        });
                    }
                }
                
            }
            if (csvarray.length>0  && this.showCSV == true) {
                var edQuery = `mutation uploadControlledPrefixes { 
                    uploadControlledPrefixes(
                        prefix_list: [`+csvarray.toString()+ `]
                    ) {
                        affected
                        changedRows
                        message
                    }
                }`;
                csvarray=[];
//                console.log(edQuery);
                const response = await API.graphql(graphqlOperation(edQuery));
                // console.log(response);
                var responseMessage = response.data.uploadControlledPrefixes;
                // console.log(totalcount);
                this.runningTotal=totalcount;
                this.uploadValue=Math.round((totalcount/this.uploadTotal)*100,0)
                this.timeLeft="0:00"
            }
            if (totalcount >= this.parse_csv.length ) {
                if (this.addType == "user") {
                    this.getData_user();
    //                        this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
                } else {
                    this.getData_org();
    //                        this.getControlledPrefixes(0,this.pagination_org.rowsPerPage);
                }
            }
            this.uploadcompleted=true;
//            this.csvHeaders.push({
//                text: 'Posted', ad_text:'Did it post successfully?', value: 'msg', align:'centre'
//            })
        },
        testCSVInput: function () {
            this.indeterminate=true;
            this.showProgress=true;
            this.uploadcompleted=false;
            this.uploadValue=0
            this.timeLeft="-:--"
            var checker;
            var reason;
            var csvmsg = '';
            var total_write = 0;
         //   console.log("starting CSV Input validation...")
            for (var i = 0; i < this.parse_csv.length ; i++) {
                checker = 0
                var entry = this.parse_csv[i]
                if (!entry.ip_prefix) {
                    this.parse_csv.splice(i, 1)
                    i -= 1
                    continue
                }
                if (entry.ip_prefix != '') {
                    if (!(entry.ip_prefix.includes(":"))) {
                        if (!(entry.ip_prefix.includes("/"))) {
                            entry.ip_prefix = entry.ip_prefix + "/32"
                        }
                        var new_4 = this.validate_4(entry.ip_prefix)
                        if (new_4 == "error") {
                            checker = 1
                            reason = "Error with IPv4 prefix"
                        } else {
                            entry.ip_prefix = new_4
                        }
                    } else {
                        if (!(entry.ip_prefix.includes("/"))) {
                            entry.ip_prefix = entry.ip_prefix + "/128"
                        }
                        var new_6 = this.validate_6(entry.ip_prefix)
                        if (new_6 == "error") {
                            checker = 1
                            reason = "Error with IPv6 prefix"
                        } else {
                            entry.ip_prefix = new_6
                        }
                    }

                } else {
                    checker = 1
                    reason = "No prefixes entered"
                }

                entry.emails = 1

                /*try {
                    if (entry.emails == 'TRUE' || entry.emails == 'Y' || entry.emails == 'y' || entry.emails == 'true' || entry.emails == 1  || entry.emails == '1') {
                        entry.emails = 1
                    } else {
                        entry.emails = 0
                    }
                } catch {
                    entry.emails = 1
                }*/

                if (checker == 1) {
                    entry.write = false
                    var addstr = "entry " + (i + 1) + " will not be written - " + reason + ". "
                    csvmsg += addstr
                } else {
                    entry.write = true
                    total_write += 1
                    try{
                        if (entry.hostname) {
                            if (entry.hostname == '') {
                                entry.hostname = "csv_insert_" + total_write
                            }
                        } else {
                            entry.hostname = "csv_insert_" + total_write
                        }
                    } catch {
                        entry.hostname = "csv_insert_" + total_write
                    }
                    
                    try {
                        if (entry.asn == '') {
                            entry.asn = 0
                        } else {
                            try {
                                var temp_n = parseInt(entry.asn)
                                if (Number.isInteger(temp_n)) {
                                    entry.asn = temp_n
                                } else {
                                    entry.asn = 0
                                }
                            } catch {
                                entry.asn = 0
                            }
                        }
                    } catch {
                        entry.asn = 0
                    }
                    try {
                        if (entry.impact_setting == '') {
                            entry.impact_setting = 0
                        } else {
                            try {
                                var temp_n = parseInt(entry.impact_setting)
                                if (Number.isInteger(temp_n)) {
                                    entry.impact_setting = temp_n
                                } else {
                                    entry.impact_setting = 80
                                }
                            } catch {
                                entry.impact_setting = 80
                            }
                        }
                    } catch {
                        entry.impact_setting = 80
                    }

                    /*
                    'own_assertions': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'own_assertions_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'path_changes': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'path_changes_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'first_seens': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    'first_seens_emails': 'Y/N, TRUE/FALSE, y/n or 1/0',
                    */

                    // ALERTS SPLIT OUT BIT

                    entry.own_path_first = ""
                    entry.opf_split = [true, false, false]
                    try {
                        if (entry.own_assertions == '') {
                            entry.own_path_first += '1' // THIS IS THE ONLY ONE WE DEFAULT TO YES
                        } else {
                            if (entry.own_assertions == 'TRUE' || entry.own_assertions == 'Y' || entry.own_assertions == 'y' || entry.own_assertions == 'true' || entry.own_assertions == 1  || entry.own_assertions == '1') {
                                entry.own_path_first += '1'

                            } else {
                                entry.own_path_first += '0'
                                entry.opf_split[0] = false
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.own_path_first.length == 0) {
                            entry.own_path_first += '1' // THIS IS THE ONLY ONE WE DEFAULT TO YES
                        }
                    }

                    try {
                        if (entry.path_changes == '') {
                            entry.own_path_first += '0'
                        } else {
                            if (entry.path_changes == 'TRUE' || entry.path_changes == 'Y' || entry.path_changes == 'y' || entry.path_changes == 'true' || entry.path_changes == 1  || entry.path_changes == '1') {
                                entry.own_path_first += '1'
                                entry.opf_split[1] = true
                            } else {
                                entry.own_path_first += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.own_path_first.length == 1) {
                            entry.own_path_first += '0'
                        }
                    }

                    try {
                        if (entry.first_seens == '') {
                            entry.own_path_first += '0'
                        } else {
                            if (entry.first_seens == 'TRUE' || entry.first_seens == 'Y' || entry.first_seens == 'y' || entry.first_seens == 'true' || entry.first_seens == 1  || entry.first_seens == '1') {
                                entry.own_path_first += '1'
                                entry.opf_split[2] = true
                            } else {
                                entry.own_path_first += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.own_path_first.length == 2) {
                            entry.own_path_first += '0'
                        }
                    }

                    try {
                        if (entry.intra_org_assertions == '') {
                            entry.own_path_first += '0'
                        } else {
                            if (entry.intra_org_assertions == 'TRUE' || entry.intra_org_assertions == 'Y' || entry.intra_org_assertions == 'y' || entry.intra_org_assertions == 'true' || entry.intra_org_assertions == 1  || entry.intra_org_assertions == '1') {
                                entry.own_path_first += '1'
                                entry.opf_split[2] = true
                            } else {
                                entry.own_path_first += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.own_path_first.length == 2) {
                            entry.own_path_first += '0'
                        }
                    }

                    // EMAILS SPLIT OUT BIT

                    entry.emails_opf = ""
                    entry.opf_split_e = [false, false, false]
                    try {
                        if (entry.own_assertions_emails == '') {
                            entry.emails_opf += '0'
                        } else {
                            if (entry.own_assertions_emails == 'TRUE' || entry.own_assertions_emails == 'Y' || entry.own_assertions_emails == 'y' || entry.own_assertions_emails == 'true' || entry.own_assertions_emails == 1  || entry.own_assertions_emails == '1') {
                                entry.emails_opf += '1'
                                entry.opf_split_e[0] = true
                            } else {
                                entry.emails_opf += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.emails_opf.length == 0) {
                            entry.emails_opf += '0'
                        }
                    }

                    try {
                        if (entry.path_changes_emails == '') {
                            entry.emails_opf += '0'
                        } else {
                            if (entry.path_changes_emails == 'TRUE' || entry.path_changes_emails == 'Y' || entry.path_changes_emails == 'y' || entry.path_changes_emails == 'true' || entry.path_changes_emails == 1  || entry.path_changes_emails == '1') {
                                entry.emails_opf += '1'
                                entry.opf_split_e[1] = true
                            } else {
                                entry.emails_opf += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.emails_opf.length == 1) {
                            entry.emails_opf += '0'
                        }
                    }

                    try {
                        if (entry.first_seens_emails == '') {
                            entry.emails_opf += '0'
                        } else {
                            if (entry.first_seens_emails == 'TRUE' || entry.first_seens_emails == 'Y' || entry.first_seens_emails == 'y' || entry.first_seens_emails == 'true' || entry.first_seens_emails == 1  || entry.first_seens_emails == '1') {
                                entry.emails_opf += '1'
                                entry.opf_split_e[2] = true
                            } else {
                                entry.emails_opf += '0'
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        if (entry.emails_opf.length == 2) {
                            entry.emails_opf += '0'
                        }
                    }







                    try {
                        var newdesc = entry.description.replace(/["“”']+/g, '');
                        var newerdesc = newdesc.replace(/(\r\n|\n|\r)/gm,"");
                        entry.description = newerdesc
                    } catch (e) {
                        console.log(entry)
                        console.log(e)
                        entry.description = ""
                    }
                        
                    try {
                        var newhost = entry.hostname.replace(/["“”']+/g, '')
                        entry.hostname = newhost
                    } catch (e) {
                        console.log(e)
                        entry.hostname = "csv_insert_" + total_write
                    }
                }
            }
            
            if( csvmsg != '') {
                this.csvErr = csvmsg;
            } else {
                this.csvErr = "All entries will be written"
            }

            if (total_write > 0) {
                this.valid3 = true
            }
            this.uploadTotal=total_write;
            this.indeterminate=false;
        },
        sortBy: function (key) {
            var vm = this
            vm.sortKey = key
            vm.sortOrders[key] = vm.sortOrders[key] * -1
        },
        csvJSON(csv){
            var vm = this
            var lines = csv.split("\n")
            var result = []
            var headers = lines[0].split(",")
          //  console.log(headers)
            vm.parse_header = lines[0].split(",") 
            lines[0].split(",").forEach(function (key) {
                vm.sortOrders[key] = 1
            })
            
            lines.map(function(line, indexLine){
                if (indexLine < 1) return // Jump header line
                
                var obj = {}
                var currentline = line.split(",")

                if (line.length>1) {
                    headers.map(function(header, indexHeader){
                        obj[header.replace(/^\s+|\s+$/g, '')] = currentline[indexHeader]
                    })
                    
                    result.push(obj)
                }
            })
            try {
                result[result.length - 1].hostname
            } catch (e) {
                console.log(e)
                result.pop() // remove the last item because undefined values
            }
                
            return result // JavaScript object
        },
        loadCSV(e) {
            this.showProgress=true;
            this.indeterminate=true;
            var vm = this;
            vm.valid3 = false;
          //  console.log("reading csv...")
            if (window.FileReader) {
                var reader = new FileReader();
                reader.readAsText(e.target.files[e.target.files.length - 1]);
                // Handle errors load
                reader.onload = function(event) {
                    var csv = event.target.result;
                    vm.parse_csv = vm.csvJSON(csv)
                  //  console.log(vm.parse_csv.length)
                    vm.showProgress=true;
                    vm.indeterminate=true;
                    if (vm.parse_csv.length > 0) {
                        vm.testCSVInput()
                    }
                
                };
                reader.onerror = function(evt) {
                    if(evt.target.error.name == "NotReadableError") {
                        alert("Cannot read file!");
                    }
                };
                
            } else {
                alert('FileReaders are not supported in this browser.');
            }
            
        },
        validate_6: function (pre) {
            var bin6 = this.ipv6_to_bin6(pre)
            var new_6 = this.bin6_to_ipv6(bin6)
            //console.log("converted " + pre + " to " + new_6)
            return new_6
        },
        validate_4: function (pre) {
    
            var b = pre.split("/")
            var cidr = parseInt(b[1])
            //console.log(cidr)
            var octs = b[0].split(".")
            //console.log(octs)
            if (octs.length < 4) {
              //  console.log("not valid prefix")
             //   console.log(pre)
             //   console.log(octs)
                return "error"
            }
            for (var i = 0; i < 4 ; i++) {
                octs[i] = parseInt(octs[i])
            }
            var n_octs = []
            for (var i = 1; i < 5 ; i++) {
                if (cidr >= 8*i) {
                    n_octs.push(octs[i-1].toString())
                } else {
                    var n = octs[i-1]
                    var p = cidr - (8*(i-1))
                    var r = 0
                    if (p > 0) {
                        for (var e = 1; e < p+1 ; e++) {
                            var t = Math.floor(n / (2**(8-e)) ) * (2**(8-e))
                            r += t
                            n -= t
                        }
                    }   
                            
                    n_octs.push(r.toString())
                }
                    
            }
            //console.log(n_octs)
            var new_prefix = n_octs.join(".") + "/" + cidr.toString()
            //console.log("converted " + pre + " to " + new_prefix)
            return new_prefix
            
        },
        bin6_to_ipv6: function (bin6) {
            
            //console.log("starting bin6 to ipv6")
            var l = bin6.length
            //console.log(l)
            var dicty = {
                '0000': '0', 
                '0001': '1', 
                '0010': '2', 
                '0011': '3', 
                '0100': '4', 
                '0101': '5',
                '0110': '6',
                '0111': '7',
                '1000': '8',
                '1001': '9',
                '1010': 'a',
                '1011': 'b',
                '1100': 'c',
                '1101': 'd',
                '1110': 'e',
                '1111': 'f'
            }
            var s = 0
            var letters = []
            while (s <= l){
                var temp_l = bin6.substring(s, s+4)
                while (temp_l.length < 4) {
                    temp_l = temp_l + "0"
                }
                var letter = dicty[temp_l]
                letters.push(letter)
                s += 4
            }
            //console.log(letters)

            while (letters.length < 32) {
                letters.push('0')
            }
            var octs = []
            for (var i = 0; i < 8 ; i++) {
                var octy = ""
                for (var j = 0; j < 4 ; j++) {
                    var lt = letters[4*i + j]
                    if (lt != '0' || j == 3 || octy != "") {
                        octy += lt
                    }
                        
                }
                octs.push(octy)
            }
            //console.log(octs)
                
            
            var n_ip6 = octs.join(":")
            var z = ['0','0','0','0','0','0','0','0']
            for (var i = 8 ; i > 1 ; i--) {
                //console.log(i)
                var zs = z.slice(0, i)
                var zu = ":" + zs.join(":")
                //console.log(zu)
                var nn_ip6 = n_ip6.replace(zu, ":")
                //console.log(nn_ip6)
                n_ip6 = nn_ip6
            }
                
            
            if (n_ip6.search(/[\da-f]:$/)) {
                n_ip6 += ":"
            }
            //console.log(n_ip6)
                
            //console.log(n_ip6 + "/" + l.toString())
            return n_ip6 + "/" + l.toString()
            
            
        },
        ipv6_to_bin6: function (ip6){
            
            //console.log("running ipv6tobin6")
            var grps = ip6.match(/([a-z\d\:]+)([\/]{1})([\d]+)/)
            var cidr = parseInt(grps[3])
            //console.log("grps:")
            //console.log(grps)
            var n_grps = grps[1].split(":")
            //console.log(n_grps)
            if (n_grps.length < 8) {
                for (var i = 0; i < 8; i++) {
                    if (n_grps[i] == "" && n_grps.length < 8) {
                        n_grps.splice(i + 1, 0, "")
                    }
                }
            }
            //console.log(n_grps)
            for (var i = 0; i < 8; i++) {
                while (n_grps[i].length < 4) {
                    n_grps[i] = "0" + n_grps[i]
                }
            }
            //console.log(n_grps)
            var ip6str = n_grps.join("")
            var j = 0
            var str_6 = ""
            var dicty = {'0': '0000', '1': '0001', '2': '0010', '3': '0011', '4': '0100', '5': '0101', '6': '0110', '7': '0111', '8': '1000', '9': '1001', 'a': '1010', 'b': '1011', 'c': '1100', 'd': '1101', 'e': '1110', 'f': '1111'}
            while (str_6.length < cidr) {
                str_6 += dicty[ip6str[j]]
                j += 1
            }
            //console.log(str_6)
            
            //console.log(str_6.substring(0, cidr))
            return str_6.substring(0, cidr)
            
        },
        viewNotif: async function (item) {
            item.noti_show = !item.noti_show;
            this.loading = true;
            this.$nextTick(() => {
            // Add the component back in
            this.loading = false;
            });

        },
        clickPrefix: function (p_hostname, p_ip4, p_ip6, p_asn, p_description, type, p_emails, p_impact, p_ip, p_opf_split, p_opf_split_e) {

            this.clearMessage();
            this.showEdit = true;

            if (type == "user") {
                this.addType = 'user'
            } else {
                this.addType = 'organisation'
            }

            if (p_hostname == "Click here to add prefix") {
                this.edType = "Add";
                this.selectedPrefix.hostname = "asdaakjirhiirbjksbksvvdvkzdjbx";
                this.selectedPrefix.ipv4 = "askjbskbkbskbcksdjc";
                this.selectedPrefix.ipv6 = "asugdasgdhasgdjfasdgijd";
                this.selectedPrefix.asn = 123433333;

                this.form.hostname = "";
                this.form.ipv4 = "";
                this.form.ipv6 = "";
                this.form.ip = "";
                this.form.asn = "";
                this.form.description = "";
                this.form.send_emails = false;
                this.form.impact = 80;
                this.form.opf_split = [
                    true,
                    false,
                    false,
                    false
                ];
                this.form.opf_split_e = [
                    false,
                    false,
                    false
                ];

            } else {
                this.edType = "Edit";
                this.selectedPrefix.hostname = p_hostname;
                this.selectedPrefix.ipv4 = p_ip4;
                this.selectedPrefix.ipv6 = p_ip6;
                this.selectedPrefix.asn = p_asn;

                this.form.opf_split = p_opf_split;
                this.form.opf_split_e = p_opf_split_e;
                this.form.hostname = p_hostname;
                this.form.ipv4 = p_ip4;
                this.form.ip = p_ip;
                this.form.ipv6 = p_ip6;
                this.form.asn = p_asn;
                this.form.description = p_description;
                this.form.send_emails = p_emails;
                this.form.impact = p_impact;
            }

            
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            this.$nextTick(() => {
                // Add the component back in
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            });
            

        },
        alertsPerASNandInfo: async function (type) {
            var dd = Math.floor((new Date() / 1000) - 86400);
            if (type == 'user') {
                var p_user = this.$store.state.user.username
            } else {
                var p_user = 'whole_organisation'
            }
            try {
                var query = `query getuserasn { getASNsForOrg ( start_time: ` + dd + `, p_user: "` + p_user + `"
                ) { asn H I V notification_count peering_asn type } }`; 
                const getASNInfo = await API.graphql(graphqlOperation(query));
                var ASNInformation = getASNInfo.data.getASNsForOrg;
                this.$store.state.allASNInfoForOrg = []

                var topush = [];
                for (var i = 0; i < ASNInformation.length; i++) {
                    if (ASNInformation[i].notification_count==null) {
                        ASNInformation[i].notification_count = 0
                    }

                    if (ASNInformation[i].type in [0, 1, 2, 3, 4]) {
                        ASNInformation[i].type = this.asnInvTypes[ASNInformation[i].type];
                    } else {
                        ASNInformation[i].type = "Not Defined"
                    }
                    var reqBreDow = {
                        H: ASNInformation[i].H,
                        I: ASNInformation[i].I,
                        V: ASNInformation[i].V,
                        asn: ASNInformation[i].asn,
                        count: ASNInformation[i].notification_count,
                        peering_asn: ASNInformation[i].peering_asn,
                        type: ASNInformation[i].type
                    }
                    topush.push(reqBreDow);
                }
                if (type == 'user') {
                    this.$store.state.allASNInfoForUser = topush;
                    var a = this.$store.state.allASNInfoForUser;
                    //console.log(a);
                    for (var i=0; i< a.length; i=i+1){
                        this.userasn.push(a[i].asn)
                    }
                } else {
                    this.$store.state.allASNInfoForOrg = topush;
                    var a = this.$store.state.allASNInfoForOrg;
                    //console.log(a);
                    for (var i=0; i< a.length; i=i+1){
                        this.asn.push(a[i].asn)
                    }

                }
                
            }
            catch (err) {
                console.log(err)
            }
        },
        editControlledPrefix: async function() {
          //  console.log("editting prefix")
            if (this.$refs.form.validate()) {
                var val_ipv = "";
                if (this.addType == "user") {
                    var p_user = this.$store.state.user.username;
                } else {
                    var p_user = 'whole_organisation';
                }

                if (this.form.asn == '') {
                    this.form.asn = 0
                }

                var emls;
                if (this.form.send_emails == true) {
                    emls = 1
                } else {
                    emls = 0
                }
                if (!(this.form.ip.includes(":"))) {
                    this.form.ipv6 = "";
                    var search = this.form.ip.match(/\//)
                    if (!search) {
                        this.form.ipv4 = this.form.ip + "/32"
                    } else {
                        search = this.form.ip.match(/\/$/)
                        if (search) {
                            this.form.ipv4 = this.form.ip + "32"
                        } else {
                            this.form.ipv4 = this.form.ip
                        }
                    }
                  //  console.log(this.form.ipv4)
                    var n_ipv4 = this.validate_4(this.form.ipv4)
                    if (n_ipv4 != this.form.ipv4 && n_ipv4 != "error") {
                        val_ipv = ", altered " + this.form.ipv4 + " to " + n_ipv4;
                        this.form.ipv4 = n_ipv4;
                    } else {
                        if ( n_ipv4 == "error") {
                            this.ipv4_err_msg = this.form.ipv4 + " - invalid prefix"
                            this.showIpv4Err = true;
                            val_ipv = ", didn't submit " + this.form.ipv4 + " - invalid prefix";
                            this.form.ipv4 = ''
                        } else {
                            val_ipv = "";
                        }
                    }
                } else {
                    this.form.ipv4 = "";
                    var search = this.form.ip.match(/\//)
                    if (!search) {
                        this.form.ipv6 = this.form.ip + "/128"
                    } else {
                        search = this.form.ip.match(/\/$/)
                        if (search) {
                            this.form.ipv6 = this.form.ip + "128"
                        } else {
                            this.form.ipv6 = this.form.ip
                        }
                    }
                   // console.log(this.form.ipv6)
                    var n_ipv6 = this.validate_6(this.form.ipv6)
                    if (n_ipv6 != this.form.ipv6 && n_ipv6 != "error") {
                        val_ipv = ", altered " + this.form.ipv6 + " to " + n_ipv6;
                        this.form.ipv6 = n_ipv6;
                    } else {
                        if ( n_ipv6 == "error") {
                            this.ipv6_err_msg = this.form.ipv6 + " - invalid prefix"
                            this.showIpv6Err = true;
                            val_ipv = ", didn't submit " + this.form.ipv6 + " - invalid prefix";
                            this.form.ipv6 = ''
                        } else {
                            val_ipv = "";
                        }
                    }
                }

                var form_opf = "";
                for ( var j = 0 ; j < this.form.opf_split.length ; j++ ) {
                    if ( this.form.opf_split[j] ) {
                        form_opf += '1'
                    } else {
                        form_opf += '0'
                    }
                }
                var form_opf_e = "";
                for ( var j = 0 ; j < this.form.opf_split_e.length ; j++ ) {
                    if ( this.form.opf_split_e[j] ) {
                        form_opf_e += '1'
                    } else {
                        form_opf_e += '0'
                    }
                }
                //console.log("form_opf")
                //console.log(form_opf)

                if (this.form.ipv4 != '' || this.form.ipv6 != '') {
                    var edQuery = `mutation editControlledPrefix {
                        updateControlledPrefix( 
                            o_hostname: "` + this.selectedPrefix.hostname + `",
                            o_ipv4: "` + this.selectedPrefix.ipv4 + `",
                            o_ipv6: "` + this.selectedPrefix.ipv6 + `",
                            o_asn: "` + this.selectedPrefix.asn + `",
                            n_hostname: "` + this.form.hostname + `",
                            n_ipv4: "` + this.form.ipv4 + `",
                            n_ipv6: "` + this.form.ipv6 + `",
                            n_asn: "` + this.form.asn + `",
                            n_description: "` + this.form.description + `",
                            organisation: "` + this.organisation + `",
                            p_user: "` + p_user + `",
                            n_send_emails: ` + emls + `,
                            p_impact: ` + this.form.impact + `,
                            p_own_path_first: "` + form_opf + `",
                            p_emails_opf: "` + form_opf_e + `"
                            ) {
                                response
                            }
                        }`;
//                    console.log(edQuery);
                    const response = await API.graphql(graphqlOperation(edQuery));
//                    console.log(response);
                    var responseMessage = response.data.updateControlledPrefix[0].response;
                    this.message = responseMessage + val_ipv
                    await this.sleep(1000)
                    if (this.addType == "user") {
                        this.getData_user();
                    } else {
                        this.getData_org();
                    }
                    this.shrinkEditWindow();

                    this.displayMessage = true;
                    this.$refs.form.resetValidation();
                }
            }

        },
        getControlledPrefixCounts: async function (usr) {
            try {

                if (usr == 'user') {
                    var p_user = this.$store.state.user.username;
                } else {
                    var p_user = 'whole_organisation'
                }

                var dd = Math.floor((new Date() / 1000) - 86400);
                var query = `query getNotificationsPerControlledPrefix {
                    getNotificationsPerControlledPrefix(
                        start_time: ` + dd + `,
                        organisation: "` + this.organisation + `",
                        p_user: "` + p_user + `",
                        ) {
                            prefix
                            controlled_prefix
                            event_count
                        }
                    }`
//                console.log(query)
                const response = await API.graphql(graphqlOperation(query));
//                console.log(response)
                var results = response.data.getNotificationsPerControlledPrefix
                if (results) {
                    if (results.length > 0) {
                        var cPreDicts = {};

                        for (var i = 0; i < results.length ; i++) {
                            var pre = results[i].prefix;
                            var cPre = results[i].controlled_prefix
                            var count = results[i].event_count
                            if (!(cPre in cPreDicts)) {
                                cPreDicts[cPre] = {"total": 0}
                            }
                            if (pre in cPreDicts[cPre]) {
                                cPreDicts[cPre][pre] += count
                            } else {
                                cPreDicts[cPre][pre] = count
                            }
                            cPreDicts[cPre]["total"] += count
                        }
 //                       console.log(cPreDicts)
                        if (usr == "user") {
                            for (var j = 0; j < this.userPrefixes.length; j++) {
                                var entries = []
                                if (this.userPrefixes[j].ipv4_address in cPreDicts) {
                                    var preDict = cPreDicts[this.userPrefixes[j].ipv4_address];
                                   // console.log(preDict)
                                    this.userPrefixes[j].notification_count = preDict["total"]
                                    var keys = Object.keys(preDict);
                                    //console.log(keys)
                                    for (var k =0; k < keys.length ; k++) {
                                        if (keys[k] != "total") {
                                            entries.push(keys[k] + ": " + preDict[keys[k]])
                                        }
                                    }
                                    
                                } else {
                                    this.userPrefixes[j].notification_count = 0
                                }
                                if (this.userPrefixes[j].ipv6_address in cPreDicts) {
                                    var preDict = cPreDicts[this.userPrefixes[j].ipv6_address];
                                    this.userPrefixes[j].notification_count += preDict["total"]
                                    var keys = Object.keys(preDict);
                                    //console.log(keys)
                                    for (var k =0; k < keys.length ; k++) {
                                        if (keys[k] != "total") {
                                            entries.push(keys[k] + ": " + preDict[keys[k]])
                                        }
                                    }
                                } else {
                                    
                                }
                                this.userPrefixes[j].notification_str = entries.join(", ")
                                this.userPrefixes[j].noti_show = false;
                                this.loading = true;
                                this.$nextTick(() => {
                                // Add the component back in
                                this.loading = false;
                                });
                            }
                        } else {
                            for (var j = 0; j < this.orgPrefixes.length; j++) {
                                var entries = []
                                if (this.orgPrefixes[j].ipv4_address in cPreDicts) {
                                    var preDict = cPreDicts[this.orgPrefixes[j].ipv4_address];
     //                               console.log(preDict)
                                    this.orgPrefixes[j].notification_count = preDict["total"]
                                    var keys = Object.keys(preDict);
                                    //console.log(keys)
                                    for (var k =0; k < keys.length ; k++) {
                                        if (keys[k] != "total") {
                                            entries.push(keys[k] + ": " + preDict[keys[k]])
                                        }
                                    }
                                    
                                } else {
                                    this.orgPrefixes[j].notification_count = 0
                                }
                                if (this.orgPrefixes[j].ipv6_address in cPreDicts) {
                                    var preDict = cPreDicts[this.orgPrefixes[j].ipv6_address];
                                    this.orgPrefixes[j].notification_count += preDict["total"]
                                    var keys = Object.keys(preDict);
                                    //console.log(keys)
                                    for (var k =0; k < keys.length ; k++) {
                                        if (keys[k] != "total") {
                                            entries.push(keys[k] + ": " + preDict[keys[k]])
                                        }
                                    }
                                } else {
                                    
                                }
                                this.orgPrefixes[j].notification_str = entries.join(", ")
                                this.orgPrefixes[j].noti_show = false;
                                this.loading = true;
                                this.$nextTick(() => {
                                // Add the component back in
                                this.loading = false;
                                });
                            }
                        }
                        

                    } else {
                        if (usr == "user") {
                            for (var j = 0; j < this.userPrefixes.length; j++) {
                                this.userPrefixes[j].notification_count = 0
                                this.userPrefixes[j].notification_str = ""
                            }
                        } else {
                            for (var j = 0; j < this.orgPrefixes.length; j++) {
                                this.orgPrefixes[j].notification_count = 0
                                this.orgPrefixes[j].notification_str = ""
                            }
                        }
                    }
                } else {
                    if (usr == "user") {
                        for (var j = 0; j < this.userPrefixes.length; j++) {
                            this.userPrefixes[j].notification_count = 0
                            this.userPrefixes[j].notification_str = ""
                        }
                    } else {
                        for (var j = 0; j < this.orgPrefixes.length; j++) {
                            this.orgPrefixes[j].notification_count = 0
                            this.orgPrefixes[j].notification_str = ""
                        }
                    }
                }
            } catch (err) {
              //  console.log(err)
                if (usr == "user") {
                    for (var j = 0; j < this.userPrefixes.length; j++) {
                        this.userPrefixes[j].notification_count = 0
                        this.userPrefixes[j].notification_str = ""
                    }
                } else {
                    for (var j = 0; j < this.orgPrefixes.length; j++) {
                        this.orgPrefixes[j].notification_count = 0
                        this.orgPrefixes[j].notification_str = ""
                    }
                }
            }
            this.loading = true;
            this.$nextTick(() => {
            // Add the component back in
            this.loading = false;
            });

        },
        clearMessage: function () {
            this.displayMessage = false;
            this.message = "";
            this.bulkUserMessage = "";
            this.bulkOrgMessage= "";

        },
        prepRemoveControlledPrefix: async function (p_hostname, p_ip4, p_ip6, p_asn, type) {

            this.clearMessage();

            this.addType = type;
            this.selectedPrefix.hostname = p_hostname;
            this.selectedPrefix.ipv4 = p_ip4;
            this.selectedPrefix.ipv6 = p_ip6;
            this.selectedPrefix.asn = p_asn;

            this.showAreYouSure = true;
        },
        removeControlledPrefix: async function() {
            this.showAreYouSure = false;
            
            if (this.addType == "user") {
                var p_user = this.$store.state.user.username;
            } else {
                var p_user = 'whole_organisation';
            }

            var remQuery = `mutation editControlledPrefix {
                deleteControlledPrefix( 
                    o_hostname: "` + this.selectedPrefix.hostname + `",
                    o_ipv4: "` + this.selectedPrefix.ipv4 + `",
                    o_ipv6: "` + this.selectedPrefix.ipv6 + `",
                    o_asn: "` + this.selectedPrefix.asn + `",
                    organisation: "` + this.organisation + `",
                    p_user: "` + p_user + `"
                    ) {
                        response
                    }
                }`;
          //  console.log(remQuery);
            const response = await API.graphql(graphqlOperation(remQuery));
          //  console.log(response);
            var responseMessage = response.data.deleteControlledPrefix[0].response;
            this.message = responseMessage;

            if (this.addType == "user") {
                this.getData_user();
//                this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
            } else {
                this.getData_org();
//                this.getControlledPrefixes(0,this.pagination_org.rowsPerPage);
            }
            this.shrinkEditWindow();

            this.displayMessage = true;

        },
        shrinkEditWindow: function() {
            this.showEdit = false;
        },
        batchOpen: async function () {
            
            this.batchPrefixes = [
                {
                    ip: '',
                },
                {
                    ip: '',
                },
                {
                    ip: '',
                },
                {
                    ip: '',
                }
            ];
            this.batchASN = null;
            this.batchHost = '';
            this.$refs.form2.resetValidation();
            this.showBatch = true;
            this.batchImpact = 80;
        },
        batchClose: async function () {
            this.showBatch = false;
            
        },    
        batchSubmit: async function () {
            // Add multiple prefixes
            if(this.$refs.form2.validate()) {
                
                if (this.addType == "user") {
                    var p_user = this.$store.state.user.username;
                } else {
                    var p_user = 'whole_organisation';
                }

                this.batchHeaders = [
                    { text: 'IPv4 / IPv6 Prefixes', value:'ip', align:'centre', sortable: false}
                ];

                var inHosts = 0;
                var j;
                for (j = 0; j < this.userPrefixes.length ; j++ ) {
                    if (this.userPrefixes[j].hostname.indexOf(this.batchHost) > -1) {
                        var inHosts = 1;
                    }
                }
                /*
                if (this.batchASN = '' || !(Number.isInteger(this.batchASN))) {
                    this.batchASN = 0
                }
                */

                var i;
                for (i = 0; i < this.batchPrefixes.length ; i++) {
                    var entry = this.batchPrefixes[i];
                    if ( entry.ip != "" ) {
                        if (!(entry.ip.includes(":"))) {
                            var search = entry.ip.match(/\//)
                            if (!search) {
                                var to_sub = entry.ip + "/32"
                            } else {
                                search = entry.ip.match(/\/$/)
                                if (search) {
                                    var to_sub = entry.ip + "32"
                                } else {
                                    var to_sub = entry.ip
                                }
                            }
                            
                            var n_ipv4 = this.validate_4(to_sub)
                            if (n_ipv4 == "error") {
                                var val_ipv4 = "didn't submit " + entry.ip + " - prefix invalid"
                                entry.ip = ''
                            } else {
                                if (n_ipv4 != entry.ip) {
                                    var val_ipv4 = "replaced " + entry.ip + " with " + n_ipv4
                                } else {
                                    var val_ipv4 = ""
                                }
                            }

                            try{
                                
                                var edQuery = `mutation editControlledPrefix {
                                    updateControlledPrefix( 
                                        o_hostname: "` + this.batchHost + ` #` + i + `",
                                        o_ipv4: "asdasd",
                                        o_ipv6: "asdasdadad",
                                        o_asn: "` + this.batchASN + `",
                                        n_hostname: "` + this.batchHost + ` #` + i + `",
                                        n_ipv4: "` + to_sub + `",
                                        n_ipv6: "",
                                        n_asn: "` + this.batchASN + `",
                                        n_description: "Batch Insert",
                                        organisation: "` + this.organisation + `",
                                        p_user: "` + p_user + `",
                                        n_send_emails: ` + 0 + `,
                                        p_impact: ` + this.batchImpact + `) {
                                            response
                                        }
                                    }`;
                                
                             //   console.log(edQuery);
                                const response = await API.graphql(graphqlOperation(edQuery));
                             //   console.log(response);
                                var responseMessage = response.data.updateControlledPrefix[0].response;
                                this.batchPrefixes[i].msg = responseMessage + " " + val_ipv4;
                            } catch (err) {
                                this.batchPrefixes[i].msg = err;
                            }

                        } else {
                            var search = entry.ip.match(/\//)
                            if (!search) {
                                var to_sub = entry.ip + "/128"
                            } else {
                                search = entry.ip.match(/\/$/)
                                if (search) {
                                    var to_sub = entry.ip + "128"
                                } else {
                                    var to_sub = entry.ip
                                }
                            }
                            
                            var n_ipv6 = this.validate_6(to_sub)
                            if (n_ipv6 == "error") {
                                var val_ipv6 = "didn't submit " + entry.ip + " - prefix invalid"
                                entry.ip = ''
                            } else {
                                if (n_ipv6 != entry.ip) {
                                    var val_ipv6 = "replaced " + entry.ip + " with " + n_ipv6
                                } else {
                                    var val_ipv6 = ""
                                }
                            }

                            try{
                                
                                var edQuery = `mutation editControlledPrefix {
                                    updateControlledPrefix( 
                                        o_hostname: "` + this.batchHost + ` #` + i + `",
                                        o_ipv4: "asdasdasd",
                                        o_ipv6: "asdasdasdasdasd",
                                        o_asn: "` + this.batchASN + `",
                                        n_hostname: "` + this.batchHost + ` #` + i + `",
                                        n_ipv4: "",
                                        n_ipv6: "` + to_sub + `",
                                        n_asn: "` + this.batchASN + `",
                                        n_description: "Batch Insert",
                                        organisation: "` + this.organisation + `",
                                        p_user: "` + p_user + `",
                                        n_send_emails: ` + 0 + `,
                                        p_impact: ` + this.batchImpact + `) {
                                            response
                                        }
                                    }`;
                              //  console.log(edQuery);
                                const response = await API.graphql(graphqlOperation(edQuery));
                              //  console.log(response);
                                var responseMessage = response.data.updateControlledPrefix[0].response;
                                this.batchPrefixes[i].msg = responseMessage + " " + val_ipv6;
                            } catch (err) {
                                this.batchPrefixes[i].msg = err;
                            }
                        }
                    }
                        
                    
                    
                }

                this.batchHeaders.push(
                    { text: 'Message', value:'msg', align:'centre', sortable: false}
                )
                if (this.addType == "user") {
                    this.getData_user();
//                    this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
                } else {
                    this.getData_user();
//                    this.getControlledPrefixes(0,this.pagination_org.rowsPerPage);
                }
//                this.getUserControlledPrefixes(0,this.pagination_user.rowsPerPage);
            }

        },
        batchGrow: async function () {
            this.batchPrefixes.push(
                {
                    ip: '',
                }
            );
        },
        doBulkDeleteUser: async function () {
            var filter_ip=this.UserFilterForm.ip_address;
            var filter_name=this.UserFilterForm.name;
            try{
                var edQuery = `mutation deleteControlledPrefixesBulk {
                            deleteControlledPrefixesBulk( 
                                organisation: "` + this.organisation +`",
                                p_user: "` + this.$store.state.user.username + `"
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                                ) {
                                    affected
                                    changedRows
                                    message
                                }
                            }`;
              //  console.log(edQuery);
                this.showBulkDeleteUser=false;
                const response = await API.graphql(graphqlOperation(edQuery));
             //   console.log(response);
                var responseMessage = response.data.deleteControlledPrefixesBulk;
                this.bulkUserMessage = "Successfully deleted " + responseMessage.affected.toString() + " entries.";
                this.displayUserBulkUpdateMessage=true;
                await this.sleep(1000)
                this.getData_user();
            } catch (e) {
                console.log(e);
            }

        },
        doBulkUpdateUser: async function () {
                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            // opfe 0=assertions 1=paths 2=firstseens
            var opf={"o":"","p":"","f":"","io":""}
            var opf_e={"o":"","p":"","f":""}
            var impact="";
            if (this.bulkUserForm.Assertions=='set') {opf.o="1"} else if (this.bulkUserForm.Assertions=='notset') {opf.o="0"}
            if (this.bulkUserForm.PathChanges=='set') {opf.p="1"} else if (this.bulkUserForm.PathChanges=='notset') {opf.p="0"}
            if (this.bulkUserForm.FirstSeens=='set') {opf.f="1"} else if (this.bulkUserForm.FirstSeens=='notset') {opf.f="0"}
            if (this.bulkUserForm.IntraOrg=='set') {opf.io="1"} else if (this.bulkUserForm.IntraOrg=='notset') {opf.io="0"}

            if (this.bulkUserForm.AssertionEmails=='set') {opf_e.o="1"} else if (this.bulkUserForm.AssertionEmails=='notset') {opf_e.o="0"}
            if (this.bulkUserForm.PathChangeEmails=='set') {opf_e.p="1"} else if (this.bulkUserForm.PathChangeEmails=='notset') {opf_e.p="0"}
            if (this.bulkUserForm.FirstSeenEmails=='set') {opf_e.f="1"} else if (this.bulkUserForm.FirstSeenEmails=='notset') {opf_e.f="0"}

            if (this.bulkUserForm.ImpactSetting=="set") {impact=this.bulkUserForm.ImpactValue};

            var filter_ip=this.UserFilterForm.ip_address;
            var filter_name=this.UserFilterForm.name;
            try {
                var edQuery = `mutation updateControlledPrefixesBulk {
                            updateControlledPrefixesBulk( 
                                organisation: "` + this.organisation +`",
                                p_user: "` + this.$store.state.user.username + `"
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                                opf_1: "` + opf.o + `"
                                opf_2: "` + opf.p + `"
                                opf_3: "` + opf.f + `"
                                opf_4: "` + opf.io + `"
                                email_opf_1: "` + opf_e.o + `"
                                email_opf_2: "` + opf_e.p + `"
                                email_opf_3: "` + opf_e.f + `"
                                impact:"` + impact + `"
                                ) {
                                    affected
                                    changedRows
                                    message
                                }
                            }`;
               // console.log(edQuery);
                this.showBulkUpdateUser=false;
                const response = await API.graphql(graphqlOperation(edQuery));
              //  console.log(response);
                var responseMessage = response.data.updateControlledPrefixesBulk;
                this.bulkUserMessage = "Successfully updated " + responseMessage.affected.toString() + " entries.";
                this.displayUserBulkUpdateMessage=true;
                await this.sleep(1000)
                this.getData_user();


            } catch (e) {
                console.log(e);
            }
        },
        doBulkDeleteOrg: async function () {
            var filter_ip=this.OrgFilterForm.ip_address;
            var filter_name=this.OrgFilterForm.name;
            try{
                var edQuery = `mutation deleteControlledPrefixesBulk {
                            deleteControlledPrefixesBulk( 
                                organisation: "` + this.organisation +`",
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                                ) {
                                    affected
                                    changedRows
                                    message
                                }
                            }`;
              //  console.log(edQuery);
                this.showBulkDeleteOrg=false;
                const response = await API.graphql(graphqlOperation(edQuery));
             //   console.log(response);
                var responseMessage = response.data.deleteControlledPrefixesBulk;
                this.bulkOrgMessage = "Successfully deleted " + responseMessage.affected.toString() + " entries.";
                this.displayOrgBulkUpdateMessage=true;
                await this.sleep(1000)
                this.getData_org();
            } catch (e) {
                console.log(e);
            }

        },
        doBulkUpdateOrg: async function () {
                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            // opfe 0=assertions 1=paths 2=firstseens
            var opf={"o":"","p":"","f":"","io":""}
            var opf_e={"o":"","p":"","f":""}
            var impact="";
            if (this.bulkOrgForm.Assertions=='set') {opf.o="1"} else if (this.bulkOrgForm.Assertions=='notset') {opf.o="0"}
            if (this.bulkOrgForm.PathChanges=='set') {opf.p="1"} else if (this.bulkOrgForm.PathChanges=='notset') {opf.p="0"}
            if (this.bulkOrgForm.FirstSeens=='set') {opf.f="1"} else if (this.bulkOrgForm.FirstSeens=='notset') {opf.f="0"}
            if (this.bulkOrgForm.IntraOrg=='set') {opf.io="1"} else if (this.bulkOrgForm.IntraOrg=='notset') {opf.io="0"}

            if (this.bulkOrgForm.AssertionEmails=='set') {opf_e.o="1"} else if (this.bulkOrgForm.AssertionEmails=='notset') {opf_e.o="0"}
            if (this.bulkOrgForm.PathChangeEmails=='set') {opf_e.p="1"} else if (this.bulkOrgForm.PathChangeEmails=='notset') {opf_e.p="0"}
            if (this.bulkOrgForm.FirstSeenEmails=='set') {opf_e.f="1"} else if (this.bulkOrgForm.FirstSeenEmails=='notset') {opf_e.f="0"}

            if (this.bulkOrgForm.ImpactSetting=="set") {impact=this.bulkOrgForm.ImpactValue};

            var filter_ip=this.OrgFilterForm.ip_address;
            var filter_name=this.OrgFilterForm.name;
            try {
                var edQuery = `mutation updateControlledPrefixesBulk {
                            updateControlledPrefixesBulk( 
                                organisation: "` + this.organisation +`",
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                                opf_1: "` + opf.o + `"
                                opf_2: "` + opf.p + `"
                                opf_3: "` + opf.f + `"
                                opf_4: "` + opf.io + `"
                                email_opf_1: "` + opf_e.o + `"
                                email_opf_2: "` + opf_e.p + `"
                                email_opf_3: "` + opf_e.f + `"
                                impact:"` + impact + `"
                                ) {
                                    affected
                                    changedRows
                                    message
                                }
                            }`;
              //  console.log(edQuery);
                this.showBulkUpdateOrg=false;
                const response = await API.graphql(graphqlOperation(edQuery));
             //   console.log(response);
                var responseMessage = response.data.updateControlledPrefixesBulk;
                this.bulkOrgMessage = "Successfully updated " + responseMessage.affected.toString() + " entries.";
                this.displayOrgBulkUpdateMessage=true;
                await this.sleep(1000)
                this.getData_org();


            } catch (e) {
                console.log(e);
            }
        },
        userDownloadClose: async function () {
            this.user_download_prefixes = [];
            this.userDownload=false;
            this.userDownloadReady=false;
        },
        orgDownloadClose: async function () {
            this.org_download_prefixes = [];
            this.orgDownload=false;
            this.orgDownloadReady=false;
        },
        ClickPrepareDownload: async function (downloadType) {
            var p_user_str='';
            var filter_ip="";
            var filter_name="";
            var orderby = "name";
            var descending = 'false';
            if (downloadType=="user") {
                filter_ip=this.UserFilterForm.ip_address;
                filter_name=this.UserFilterForm.name;
                this.userCount=0;
                this.userDownload=true;
                this.userDownloadReady=false;
                this.user_download_prefixes = [];
                p_user_str=`p_user: "` + this.$store.state.user.username + `"`;
            } else {
                filter_ip=this.OrgFilterForm.ip_address;
                filter_name=this.OrgFilterForm.name;
                this.orgDownload=true;
                this.orgDownloadReady=false;
                this.org_download_prefixes = [];
                p_user_str="";
            }
            try {
                var prefsCountQuery = `
                    query getControlledPrefixesCountQuery { 
                        getControlledPrefixesCount(
                            organisation: "` + this.organisation +`",
                            ` + p_user_str + `
                            filter_ip: "` + filter_ip + `"
                            filter_name: "` + filter_name + `"
                        ) { 
                        count 
                        own_path_first
                        emails_opf                    
                        } 
                    }`;
                //  console.log(prefsCountQuery);
                const prefCount = await API.graphql(graphqlOperation(prefsCountQuery));
                //   console.log(prefCount)
                var prefCountVal = prefCount.data.getControlledPrefixesCount;
                var filteredcount=0;
                try {
                    for (var i = 0; i < prefCountVal.length ; i++) {
                        filteredcount+=prefCountVal[i].count;
                    }
                } catch(err) {
                    console.log(err);
                    console.log("An Error has occurred: " + err.errors[0].message);
                }

            } catch(err) {
                console.log(err);
                console.log("An Error has occurred: " + err.errors[0].message);
            }
            //  console.log(allalerts);
            var recordcount=0;
            var offset=0;
            var limit=1000;

            while (recordcount<filteredcount) {
            try {
                var prefsQuery = `query getControlledPrefixesQuery { getControlledPrefixes(
                    organisation: "` + this.organisation +`",
                    ` + p_user_str + `
                    filter_ip: "` + filter_ip + `"
                    filter_name: "` + filter_name + `"
                    orderby: "` + orderby + `"
                    descending: `+ descending +`
                    offset: `+ offset + `
                    limit: ` + limit + `
                ) { 
                                hostname
                                ipv4_address
                                ipv6_address
                                asn
                                description
                                send_emails
                                impact_setting
                                own_path_first
                                emails_opf
                    } 
                                }`;
//                    console.log(prefsQuery);
                const prefData = await API.graphql(graphqlOperation(prefsQuery));
                var prefs = prefData.data.getControlledPrefixes;
//                    console.log(prefs)

                if (prefs.length > 0) {
                    for (var i = 0; i < prefs.length ; i++) {
                        try {
                            prefs[i].opf_split = prefs[i].own_path_first.split("")
                            for ( var j = 0 ; j < prefs[i].opf_split.length ; j++ ) {
                                prefs[i].opf_split[j] = prefs[i].opf_split[j] == 1 ? true : false;
                            }
                        } catch (e) {
                            console.log(e)
                            prefs[i].opf_split = [true, false, false]
                        }

                        try {
                            prefs[i].opf_split_e = prefs[i].emails_opf.split("")
                            for ( var j = 0 ; j < prefs[i].opf_split_e.length ; j++ ) {
                                prefs[i].opf_split_e[j] = prefs[i].opf_split_e[j] == 1 ? true : false;
                            }
                        } catch (e) {
                            console.log(e)
                            prefs[i].opf_split_e = [false, false, false]
                        }

                        if (prefs[i].send_emails == 1) {
                            prefs[i].send_emails = true;
                            prefs[i].email_icon = "check";
                        } else {
                            prefs[i].send_emails = false;
                            prefs[i].email_icon = "clear";
                        }
                        if (prefs[i].ipv4_address == '') {
                            prefs[i].ip_address = prefs[i].ipv6_address
                        } else {
                            prefs[i].ip_address = prefs[i].ipv4_address
                        }
                        // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                        // opfe 0=assertions 1=paths 2=firstseens
                        if (downloadType=='user') {
                            this.user_download_prefixes.push({
                            'hostname': prefs[i].hostname,
                            'ip_prefix': prefs[i].ip_address,
                            'asn': prefs[i].asn,
                            'impact_setting': prefs[i].impact_setting,
                            'own_assertions': prefs[i].opf_split[0] ? 'Y' : 'N',
                            'intra_org_assertions': prefs[i].opf_split[3] ? 'Y' : 'N',
                            'own_assertions_emails': prefs[i].opf_split_e[0] ? 'Y' : 'N',
                            'path_changes': prefs[i].opf_split[1] ? 'Y' : 'N',
                            'path_changes_emails': prefs[i].opf_split_e[1] ? 'Y' : 'N',
                            'first_seens': prefs[i].opf_split[2] ? 'Y' : 'N',
                            'first_seens_emails': prefs[i].opf_split_e[2] ? 'Y' : 'N',
                            'description': prefs[i].description})
                        } else {
                            this.org_download_prefixes.push({
                            'hostname': prefs[i].hostname,
                            'ip_prefix': prefs[i].ip_address,
                            'asn': prefs[i].asn,
                            'impact_setting': prefs[i].impact_setting,
                            'own_assertions': prefs[i].opf_split[0] ? 'Y' : 'N',
                            'intra_org_assertions': prefs[i].opf_split[3] ? 'Y' : 'N',
                            'own_assertions_emails': prefs[i].opf_split_e[0] ? 'Y' : 'N',
                            'path_changes': prefs[i].opf_split[1] ? 'Y' : 'N',
                            'path_changes_emails': prefs[i].opf_split_e[1] ? 'Y' : 'N',
                            'first_seens': prefs[i].opf_split[2] ? 'Y' : 'N',
                            'first_seens_emails': prefs[i].opf_split_e[2] ? 'Y' : 'N',
                            'description': prefs[i].description})
                        }
                    }
                }
            } catch(err) {
                console.log( err)
                console.log("An Error has occurred: " + err.errors[0].message)
            }
            offset+=prefs.length;
            recordcount+=prefs.length;
            this.userCount=recordcount;
//            console.log(offset);
//            console.log(filteredcount);
            if(downloadType=='user'){
                this.userDownloadProgress=100*(recordcount/filteredcount)
            } else {
                this.orgDownloadProgress=100*(recordcount/filteredcount)
            }
        }                
        if(downloadType=='user'){
            this.userDownloadReady=true;
        } else {
            this.orgDownloadReady=true;
        }
    },
    getData_user: async function () {
    //            console.log("starting user "+this.userloading + "  " + this.loading2)
            var currentpage=this.pagination_user.page;
            var offset=(this.pagination_user.page-1)*this.pagination_user.rowsPerPage;
            var limit=this.pagination_user.rowsPerPage;
            if (this.userloading == false){
//                console.log("updating")
                this.userloading=true;
                this.getUserControlledPrefixes(offset,limit).then(data => {
                    this.userloading=false;
//                    console.log("user finished")
                    if (currentpage!=this.pagination_user.page) {
                     //   console.log("catching up")
                        this.getData_user();
                    }
                })
            }
        },
        getData_org: async function () {
//          console.log("starting org "+this.orgloading + "  " + this.loading)
            var currentpage=this.pagination_org.page;
            var offset=(this.pagination_org.page-1)*this.pagination_org.rowsPerPage;
            var limit=this.pagination_org.rowsPerPage;
            if (this.orgloading == false){
    //             console.log("updating")
                this.orgloading=true;
                this.getControlledPrefixes(offset,limit).then(data => {
                    this.orgloading=false;
    //                 console.log("org finished")
                    if (currentpage!=this.pagination_org.page) {
                          //  console.log("catching up")
                        this.getData_org();
                    }
                })
            }
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        ApplyOrgFilter: async function () {
            this.bulkOrgMessage = "";
            this.displayOrgBulkUpdateMessage=false;
            this.getData_org();
        },
        ApplyUserFilter: async function () {
            this.bulkUserMessage = "";
            this.displayUserBulkUpdateMessage=false;
            this.getData_user();
        },
        getControlledPrefixes: async function (offset,limit) {
                var allalerts = {
                    impactsetting:'',
                    impactmin:null,
                    impactmax:null,
                    impactvalue:0,
                    assertions:'',
                    assertionscount_set:0,
                    assertionscount_notset:0,
                    assertionemailscount_set:0,
                    assertionemailscount_notset:0,
                    assertionemails:'',
                    intraorg:'',
                    intraorgcount_set:0,
                    intraorgcount_notset:0,
                    pathchanges:'',
                    pathchangeemails:'',
                    pathchangescount_set:0,
                    pathchangescount_notset:0,
                    pathchangeemailscount_set:0,
                    pathchangeemailscount_notset:0,
                    firstseens:'',
                    firstseenemails:'',
                    firstseenscount_set:0,
                    firstseenscount_notset:0,
                    firstseenemailscount_set:0,
                    firstseenemailscount_notset:0
                }
                this.loading = true;
                var filter_ip=this.OrgFilterForm.ip_address;
                var filter_name=this.OrgFilterForm.name;
                this.org_download_prefixes = [];
                var orderby = this.pagination_org.sortBy;
                if (orderby === undefined) {
                    orderby='name';
                }
                var descending = 'false';
                if (this.pagination_org.descending) {
                    descending = 'true';
                }
//                var direction = this.pagination_org.descending;

                try {
                    var prefsCountQuery = `
                        query getControlledPrefixesCountQuery { 
                            getControlledPrefixesCount(
                                organisation: "` + this.organisation +`",
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                            ) { 
                            count 
                            own_path_first
                            emails_opf                    
                            impact_min
                            impact_max                  
                            } 
                        }`;
                   // console.log(prefsCountQuery);
                    const prefCount = await API.graphql(graphqlOperation(prefsCountQuery));
                   // console.log(prefCount)
                    var prefCountVal = prefCount.data.getControlledPrefixesCount;
                    var filteredcount=0;
                    try {
                        for (var i = 0; i < prefCountVal.length ; i++) {
                            try {
                                if (allalerts.impactmin==null || allalerts.impactmax==null) {
                                    allalerts.impactmin=prefCountVal[i].impact_min;
                                    allalerts.impactmax=prefCountVal[i].impact_max;
                                }
                                if (prefCountVal[i].impact_min<allalerts.impactmin) {
                                    allalerts.impactmin=prefCountVal[i].impact_min;
                                }
                                if (prefCountVal[i].impact_max>allalerts.impactmax) {
                                    allalerts.impactmax=prefCountVal[i].impact_max;
                                }
                            } catch (e) {
                                console.log(e)
                            }
                            try {
                                prefCountVal[i].opf_split = prefCountVal[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefCountVal[i].opf_split.length ; j++ ) {
                                    prefCountVal[i].opf_split[j] = prefCountVal[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefCountVal[i].opf_split = [true, false, false]
                            }

                            try {
                                prefCountVal[i].opf_split_e = prefCountVal[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefCountVal[i].opf_split_e.length ; j++ ) {
                                    prefCountVal[i].opf_split_e[j] = prefCountVal[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefCountVal[i].opf_split_e = [false, false, false]
                            }

                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            // opfe 0=assertions 1=paths 2=firstseens
                            if (prefCountVal[i].opf_split[0]) {
                                allalerts.assertionscount_set+=prefCountVal[i].count;
                                if (allalerts.assertions=='') {allalerts.assertions='set'; } 
                                else if (allalerts.assertions=='notset') {allalerts.assertions='mixed';}
                            } else {
                                allalerts.assertionscount_notset+=prefCountVal[i].count;
                                if (allalerts.assertions=='') {allalerts.assertions='notset';} 
                                else if (allalerts.assertions=='set') {allalerts.assertions='mixed';}
                            }
                            if (prefCountVal[i].opf_split[1]) {
                                allalerts.pathchangescount_set+=prefCountVal[i].count;
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='set';} 
                                else if (allalerts.pathchanges=='notset') {allalerts.pathchanges='mixed';}
                            } else {
                                allalerts.pathchangescount_notset+=prefCountVal[i].count;
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='notset';} 
                                else if (allalerts.pathchanges=='set') {allalerts.pathchanges='mixed';}
                            }
                            if (prefCountVal[i].opf_split[2]) {
                                allalerts.firstseenscount_set+=prefCountVal[i].count;
                                if (allalerts.firstseens=='') {allalerts.firstseens='set';} 
                                else if (allalerts.firstseens=='notset') {allalerts.firstseens='mixed';}
                            } else {
                                allalerts.firstseenscount_notset+=prefCountVal[i].count;
                                if (allalerts.firstseens=='') {allalerts.firstseens='notset';} 
                                else if (allalerts.firstseens=='set') {allalerts.firstseens='mixed';}
                            }
                            if (prefCountVal[i].opf_split[3]) {
                                allalerts.intraorgcount_set+=prefCountVal[i].count;
                                if (allalerts.intraorg=='') {allalerts.intraorg='set';} 
                                else if (allalerts.intraorg=='notset') {allalerts.intraorg='mixed';}
                            } else {
                                allalerts.intraorgcount_notset+=prefCountVal[i].count;
                                if (allalerts.intraorg=='') {allalerts.intraorg='notset';} 
                                else if (allalerts.intraorg=='set') {allalerts.intraorg='mixed';}
                            }


                            if (prefCountVal[i].opf_split_e[0]) {
                                allalerts.assertionemailscount_set+=prefCountVal[i].count;
                                if (allalerts.assertionemails=='') {allalerts.assertionemails='set';} 
                                else if (allalerts.assertionemails=='notset') {allalerts.assertionemails='mixed';}
                            } else {
                                allalerts.assertionemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.assertionemails=='') {allalerts.assertionemails='notset';} 
                                else if (allalerts.assertionemails=='set') {allalerts.assertionemails='mixed';}
                            }
                            if (prefCountVal[i].opf_split_e[1]) {
                                allalerts.pathchangeemailscount_set+=prefCountVal[i].count;
                                if (allalerts.pathchangeemails=='') {allalerts.pathchangeemails='set';} 
                                else if (allalerts.pathchangeemails=='notset') {allalerts.pathchangeemails='mixed';}
                            } else {
                                allalerts.pathchangeemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.pathchangeemails=='') {allalerts.pathchangeemails='notset';} 
                                else if (allalerts.pathchangeemails=='set') {allalerts.pathchangeemails='mixed';}
                            }
                            if (prefCountVal[i].opf_split_e[2]) {
                                allalerts.firstseenemailscount_set+=prefCountVal[i].count;
                                if (allalerts.firstseenemails=='') {allalerts.firstseenemails='set';} 
                                else if (allalerts.firstseenemails=='notset') {allalerts.firstseenemails='mixed';}
                            } else {
                                allalerts.firstseenemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.firstseenemails=='') {allalerts.firstseenemails='notset';} 
                                else if (allalerts.firstseenemails=='set') {allalerts.firstseenemails='mixed';}
                            }

                            filteredcount+=prefCountVal[i].count;
                        }
                    } catch(err) {
                        console.log(err);
                        console.log("An Error has occurred: " + err.errors[0].message);
                    }

                } catch(err) {
                    console.log(err);
                    console.log("An Error has occurred: " + err.errors[0].message);
                }
             //   console.log(allalerts);
                if (allalerts.impactmax>allalerts.impactmin) {
                    this.bulkOrgForm.ImpactSetting='mixed'
                    this.bulkOrgForm.ImpactValue=allalerts.impactmin;
                } else {
                    this.bulkOrgForm.ImpactSetting='set'
                    this.bulkOrgForm.ImpactValue=allalerts.impactmin;
                }
                this.totalOrgResults=filteredcount;
                this.bulkOrgForm.ImpactMax=allalerts.impactmax;
                this.bulkOrgForm.ImpactMin=allalerts.impactmin;
                this.bulkOrgForm.Assertions=allalerts.assertions;
                this.bulkOrgForm.PathChanges=allalerts.pathchanges;
                this.bulkOrgForm.FirstSeens=allalerts.firstseens;
                this.bulkOrgForm.IntraOrg=allalerts.intraorg;
                this.bulkOrgForm.AssertionsCount_Set=allalerts.assertionscount_set;
                this.bulkOrgForm.AssertionsCount_NotSet=allalerts.assertionscount_notset;
                this.bulkOrgForm.PathChangesCount_Set=allalerts.pathchangescount_set;
                this.bulkOrgForm.PathChangesCount_NotSet=allalerts.pathchangescount_notset;
                this.bulkOrgForm.FirstSeensCount_Set=allalerts.firstseenscount_set;
                this.bulkOrgForm.FirstSeensCount_NotSet=allalerts.firstseenscount_notset;
                this.bulkOrgForm.IntraOrgCount_Set=allalerts.intraorgcount_set;
                this.bulkOrgForm.IntraOrgCount_NotSet=allalerts.intraorgcount_notset;

                if (allalerts.assertions=='mixed') {this.bulkOrgForm.AssertionsMixedDisabled=false} else {this.bulkOrgForm.AssertionsMixedDisabled=true}
                if (allalerts.pathchanges=='mixed') {this.bulkOrgForm.PathChangesMixedDisabled=false} else {this.bulkOrgForm.PathChangesMixedDisabled=true}
                if (allalerts.firstseens=='mixed') {this.bulkOrgForm.FirstSeensMixedDisabled=false} else {this.bulkOrgForm.FirstSeensMixedDisabled=true}
                if (allalerts.intraorg=='mixed') {this.bulkOrgForm.IntraOrgMixedDisabled=false} else {this.bulkOrgForm.IntraOrgMixedDisabled=true}

                this.bulkOrgForm.AssertionEmails=allalerts.assertionemails;
                this.bulkOrgForm.PathChangeEmails=allalerts.pathchangeemails;
                this.bulkOrgForm.FirstSeenEmails=allalerts.firstseenemails;

                this.bulkOrgForm.AssertionEmailsCount_Set=allalerts.assertionemailscount_set;
                this.bulkOrgForm.AssertionEmailsCount_NotSet=allalerts.assertionemailscount_notset;
                this.bulkOrgForm.PathChangeEmailsCount_Set=allalerts.pathchangeemailscount_set;
                this.bulkOrgForm.PathChangeEmailsCount_NotSet=allalerts.pathchangeemailscount_notset;
                this.bulkOrgForm.FirstSeenEmailsCount_Set=allalerts.firstseenemailscount_set;
                this.bulkOrgForm.FirstSeenEmailsCount_NotSet=allalerts.firstseenemailscount_notset;

                if (allalerts.assertionemails=='mixed') {this.bulkOrgForm.AssertionEmailsMixedDisabled=false} else {this.bulkOrgForm.AssertionEmailsMixedDisabled=true}
                if (allalerts.pathchangeemails=='mixed') {this.bulkOrgForm.PathChangeEmailsMixedDisabled=false} else {this.bulkOrgForm.PathChangeEmailsMixedDisabled=true}
                if (allalerts.firstseenemails=='mixed') {this.bulkOrgForm.FirstSeenEmailsMixedDisabled=false} else {this.bulkOrgForm.FirstSeenEmailsMixedDisabled=true}


                try {
                    var prefsQuery = `query getControlledPrefixesQuery { 
                            getControlledPrefixes(
                                organisation: "` + this.organisation +`"
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                                orderby: "` + orderby + `"
                                descending: `+ descending +` 
                                offset: `+ offset + `
                                limit: ` + limit + `
                    ) { 
                                    hostname
                                    ipv4_address
                                    ipv6_address
                                    asn
                                    description
                                    send_emails
                                    impact_setting
                                    own_path_first
                                    emails_opf
                     } 
                                    }`;
                    //console.log(prefsQuery)
                    const prefData = await API.graphql(graphqlOperation(prefsQuery));
                    var prefs = prefData.data.getControlledPrefixes;
                    var allalerts = {
                        assertions:'',
                        assertionemails:'',
                        intraorg:'',
                        pathchanges:'',
                        pathchangeemails:'',
                        firstseens:'',
                        firstseenemails:''
                    }
                    //console.log(prefData)
                    if (prefs.length == 0 || prefs === undefined) {
                        this.orgPrefixes = [];
                    } else {
                        for (var i = 0; i < prefs.length ; i++) {
                            try {
                                prefs[i].opf_split = prefs[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split.length ; j++ ) {
                                    prefs[i].opf_split[j] = prefs[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split = [false, false, false, false]
                            }

                            try {
                                prefs[i].opf_split_e = prefs[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split_e.length ; j++ ) {
                                    prefs[i].opf_split_e[j] = prefs[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split_e = [false, false, false]
                            }

                            if (prefs[i].send_emails == 1) {
                                prefs[i].send_emails = true;
                                prefs[i].email_icon = "check";
                            } else {
                                prefs[i].send_emails = false;
                                prefs[i].email_icon = "clear";
                            }
                            if (prefs[i].ipv4_address == '') {
                                prefs[i].ip_address = prefs[i].ipv6_address
                            } else {
                                prefs[i].ip_address = prefs[i].ipv4_address
                            }
                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            if (prefs[i].opf_split[0]) {
                                if (allalerts.assertions=='') {allalerts.assertions='set';} 
                                else if (allalerts.assertions=='notset') {allalerts.assertions='mixed';}
                            } else {
                                if (allalerts.assertions=='') {allalerts.assertions='notset';} 
                                else if (allalerts.assertions=='set') {allalerts.assertions='mixed';}
                            }
                            if (prefs[i].opf_split[1]) {
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='set';} 
                                else if (allalerts.pathchanges=='notset') {allalerts.pathchanges='mixed';}
                            } else {
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='notset';} 
                                else if (allalerts.pathchanges=='set') {allalerts.pathchanges='mixed';}
                            }
                            if (prefs[i].opf_split[2]) {
                                if (allalerts.firstseens=='') {allalerts.firstseens='set';} 
                                else if (allalerts.firstseens=='notset') {allalerts.firstseens='mixed';}
                            } else {
                                if (allalerts.firstseens=='') {allalerts.firstseens='notset';} 
                                else if (allalerts.firstseens=='set') {allalerts.firstseens='mixed';}
                            }
                            if (prefs[i].opf_split[3]) {
                                if (allalerts.intraorg=='') {allalerts.intraorg='set';} 
                                else if (allalerts.intraorg=='notset') {allalerts.intraorg='mixed';}
                            } else {
                                if (allalerts.intraorg=='') {allalerts.intraorg='notset';} 
                                else if (allalerts.intraorg=='set') {allalerts.intraorg='mixed';}
                            }
                            this.organisation_download_prefixes.push({
                                'hostname': prefs[i].hostname,
                                'ip_prefix': prefs[i].ip_address,
                                'asn': prefs[i].asn,
                                'impact_setting': prefs[i].impact_setting,
                                'own_assertions': prefs[i].opf_split[0] ? 'Y' : 'N',
                                'intra_org_assertions': prefs[i].opf_split[3] ? 'Y' : 'N',
                                'own_assertions_emails': prefs[i].opf_split_e[0] ? 'Y' : 'N',
                                'path_changes': prefs[i].opf_split[1] ? 'Y' : 'N',
                                'path_changes_emails': prefs[i].opf_split_e[1] ? 'Y' : 'N',
                                'first_seens': prefs[i].opf_split[2] ? 'Y' : 'N',
                                'first_seens_emails': prefs[i].opf_split_e[2] ? 'Y' : 'N',
                                'description': prefs[i].description
                            })

                        }
                        this.orgPrefixes = prefs;
                    }
                } catch(err) {
                    console.log( err)
                    console.log("An Error has occurred: " + err.errors[0].message)
                }
                this.loading = false;
                
                await this.getControlledPrefixCounts('organisation');
            
        },
        getUserControlledPrefixes: async function (offset,limit) {
            
                var allalerts = {
                    impactsetting:'',
                    impactmin:null,
                    impactmax:null,
                    impactvalue:0,
                    assertions:'',
                    assertionscount_set:0,
                    assertionscount_notset:0,
                    assertionemailscount_set:0,
                    assertionemailscount_notset:0,
                    assertionemails:'',
                    intraorg:'',
                    intraorgcount_set:0,
                    intraorgcount_notset:0,
                    pathchanges:'',
                    pathchangeemails:'',
                    pathchangescount_set:0,
                    pathchangescount_notset:0,
                    pathchangeemailscount_set:0,
                    pathchangeemailscount_notset:0,
                    firstseens:'',
                    firstseenemails:'',
                    firstseenscount_set:0,
                    firstseenscount_notset:0,
                    firstseenemailscount_set:0,
                    firstseenemailscount_notset:0
                }
                this.loading2 = true;
                var filter_ip=this.UserFilterForm.ip_address;
                var filter_name=this.UserFilterForm.name;
                this.user_download_prefixes = [];
                var orderby = this.pagination_user.sortBy;
                if (orderby === undefined) {
                    orderby='name';
                }
                var descending = 'false';
                if (this.pagination_user.descending) {
                    descending = 'true';
                }
//                var direction = this.pagination_user.descending;

                try {
                    var prefsCountQuery = `
                        query getControlledPrefixesCountQuery { 
                            getControlledPrefixesCount(
                                organisation: "` + this.organisation +`",
                                p_user: "` + this.$store.state.user.username + `"
                                filter_ip: "` + filter_ip + `"
                                filter_name: "` + filter_name + `"
                            ) { 
                            count 
                            own_path_first
                            emails_opf
                            impact_min
                            impact_max                  
                            } 
                        }`;
                  //  console.log(prefsCountQuery);
                    const prefCount = await API.graphql(graphqlOperation(prefsCountQuery));
                  //  console.log(prefCount)
                    var prefCountVal = prefCount.data.getControlledPrefixesCount;
                    var filteredcount=0;
                    try {
                        for (var i = 0; i < prefCountVal.length ; i++) {
                            try {
                                if (allalerts.impactmin==null || allalerts.impactmax==null) {
                                    allalerts.impactmin=prefCountVal[i].impact_min;
                                    allalerts.impactmax=prefCountVal[i].impact_max;
                                }
                                if (prefCountVal[i].impact_min<allalerts.impactmin) {
                                    allalerts.impactmin=prefCountVal[i].impact_min;
                                }
                                if (prefCountVal[i].impact_max>allalerts.impactmax) {
                                    allalerts.impactmax=prefCountVal[i].impact_max;
                                }
                            } catch (e) {
                                console.log(e)
                            }
                            try {
                                prefCountVal[i].opf_split = prefCountVal[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefCountVal[i].opf_split.length ; j++ ) {
                                    prefCountVal[i].opf_split[j] = prefCountVal[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefCountVal[i].opf_split = [true, false, false]
                            }

                            try {
                                prefCountVal[i].opf_split_e = prefCountVal[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefCountVal[i].opf_split_e.length ; j++ ) {
                                    prefCountVal[i].opf_split_e[j] = prefCountVal[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefCountVal[i].opf_split_e = [false, false, false]
                            }

                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            // opfe 0=assertions 1=paths 2=firstseens
                            if (prefCountVal[i].opf_split[0]) {
                                allalerts.assertionscount_set+=prefCountVal[i].count;
                                if (allalerts.assertions=='') {allalerts.assertions='set'; } 
                                else if (allalerts.assertions=='notset') {allalerts.assertions='mixed';}
                            } else {
                                allalerts.assertionscount_notset+=prefCountVal[i].count;
                                if (allalerts.assertions=='') {allalerts.assertions='notset';} 
                                else if (allalerts.assertions=='set') {allalerts.assertions='mixed';}
                            }
                            if (prefCountVal[i].opf_split[1]) {
                                allalerts.pathchangescount_set+=prefCountVal[i].count;
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='set';} 
                                else if (allalerts.pathchanges=='notset') {allalerts.pathchanges='mixed';}
                            } else {
                                allalerts.pathchangescount_notset+=prefCountVal[i].count;
                                if (allalerts.pathchanges=='') {allalerts.pathchanges='notset';} 
                                else if (allalerts.pathchanges=='set') {allalerts.pathchanges='mixed';}
                            }
                            if (prefCountVal[i].opf_split[2]) {
                                allalerts.firstseenscount_set+=prefCountVal[i].count;
                                if (allalerts.firstseens=='') {allalerts.firstseens='set';} 
                                else if (allalerts.firstseens=='notset') {allalerts.firstseens='mixed';}
                            } else {
                                allalerts.firstseenscount_notset+=prefCountVal[i].count;
                                if (allalerts.firstseens=='') {allalerts.firstseens='notset';} 
                                else if (allalerts.firstseens=='set') {allalerts.firstseens='mixed';}
                            }
                            if (prefCountVal[i].opf_split[3]) {
                                allalerts.intraorgcount_set+=prefCountVal[i].count;
                                if (allalerts.intraorg=='') {allalerts.intraorg='set';} 
                                else if (allalerts.intraorg=='notset') {allalerts.intraorg='mixed';}
                            } else {
                                allalerts.intraorgcount_notset+=prefCountVal[i].count;
                                if (allalerts.intraorg=='') {allalerts.intraorg='notset';} 
                                else if (allalerts.intraorg=='set') {allalerts.intraorg='mixed';}
                            }


                            if (prefCountVal[i].opf_split_e[0]) {
                                allalerts.assertionemailscount_set+=prefCountVal[i].count;
                                if (allalerts.assertionemails=='') {allalerts.assertionemails='set';} 
                                else if (allalerts.assertionemails=='notset') {allalerts.assertionemails='mixed';}
                            } else {
                                allalerts.assertionemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.assertionemails=='') {allalerts.assertionemails='notset';} 
                                else if (allalerts.assertionemails=='set') {allalerts.assertionemails='mixed';}
                            }
                            if (prefCountVal[i].opf_split_e[1]) {
                                allalerts.pathchangeemailscount_set+=prefCountVal[i].count;
                                if (allalerts.pathchangeemails=='') {allalerts.pathchangeemails='set';} 
                                else if (allalerts.pathchangeemails=='notset') {allalerts.pathchangeemails='mixed';}
                            } else {
                                allalerts.pathchangeemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.pathchangeemails=='') {allalerts.pathchangeemails='notset';} 
                                else if (allalerts.pathchangeemails=='set') {allalerts.pathchangeemails='mixed';}
                            }
                            if (prefCountVal[i].opf_split_e[2]) {
                                allalerts.firstseenemailscount_set+=prefCountVal[i].count;
                                if (allalerts.firstseenemails=='') {allalerts.firstseenemails='set';} 
                                else if (allalerts.firstseenemails=='notset') {allalerts.firstseenemails='mixed';}
                            } else {
                                allalerts.firstseenemailscount_notset+=prefCountVal[i].count;
                                if (allalerts.firstseenemails=='') {allalerts.firstseenemails='notset';} 
                                else if (allalerts.firstseenemails=='set') {allalerts.firstseenemails='mixed';}
                            }


                            filteredcount+=prefCountVal[i].count;
                        }
                    } catch(err) {
                        console.log(err);
                        console.log("An Error has occurred: " + err.errors[0].message);
                    }

                } catch(err) {
                    console.log(err);
                    console.log("An Error has occurred: " + err.errors[0].message);
                }
              //  console.log(allalerts);
                if (allalerts.impactmax>allalerts.impactmin) {
                    this.bulkUserForm.ImpactSetting='mixed'
                    this.bulkUserForm.ImpactValue=allalerts.impactmin;
                } else {
                    this.bulkUserForm.ImpactSetting='set'
                    this.bulkUserForm.ImpactValue=allalerts.impactmin;
                }
                this.totalUserResults=filteredcount;
                this.bulkUserForm.ImpactMax=allalerts.impactmax;
                this.bulkUserForm.ImpactMin=allalerts.impactmin;
                this.bulkUserForm.Assertions=allalerts.assertions;
                this.bulkUserForm.PathChanges=allalerts.pathchanges;
                this.bulkUserForm.FirstSeens=allalerts.firstseens;
                this.bulkUserForm.IntraOrg=allalerts.intraorg;
                this.bulkUserForm.AssertionsCount_Set=allalerts.assertionscount_set;
                this.bulkUserForm.AssertionsCount_NotSet=allalerts.assertionscount_notset;
                this.bulkUserForm.PathChangesCount_Set=allalerts.pathchangescount_set;
                this.bulkUserForm.PathChangesCount_NotSet=allalerts.pathchangescount_notset;
                this.bulkUserForm.FirstSeensCount_Set=allalerts.firstseenscount_set;
                this.bulkUserForm.FirstSeensCount_NotSet=allalerts.firstseenscount_notset;
                this.bulkUserForm.IntraOrgCount_Set=allalerts.intraorgcount_set;
                this.bulkUserForm.IntraOrgCount_NotSet=allalerts.intraorgcount_notset;

                if (allalerts.assertions=='mixed') {this.bulkUserForm.AssertionsMixedDisabled=false} else {this.bulkUserForm.AssertionsMixedDisabled=true}
                if (allalerts.pathchanges=='mixed') {this.bulkUserForm.PathChangesMixedDisabled=false} else {this.bulkUserForm.PathChangesMixedDisabled=true}
                if (allalerts.firstseens=='mixed') {this.bulkUserForm.FirstSeensMixedDisabled=false} else {this.bulkUserForm.FirstSeensMixedDisabled=true}
                if (allalerts.intraorg=='mixed') {this.bulkUserForm.IntraOrgMixedDisabled=false} else {this.bulkUserForm.IntraOrgMixedDisabled=true}

                this.bulkUserForm.AssertionEmails=allalerts.assertionemails;
                this.bulkUserForm.PathChangeEmails=allalerts.pathchangeemails;
                this.bulkUserForm.FirstSeenEmails=allalerts.firstseenemails;

                this.bulkUserForm.AssertionEmailsCount_Set=allalerts.assertionemailscount_set;
                this.bulkUserForm.AssertionEmailsCount_NotSet=allalerts.assertionemailscount_notset;
                this.bulkUserForm.PathChangeEmailsCount_Set=allalerts.pathchangeemailscount_set;
                this.bulkUserForm.PathChangeEmailsCount_NotSet=allalerts.pathchangeemailscount_notset;
                this.bulkUserForm.FirstSeenEmailsCount_Set=allalerts.firstseenemailscount_set;
                this.bulkUserForm.FirstSeenEmailsCount_NotSet=allalerts.firstseenemailscount_notset;

                if (allalerts.assertionemails=='mixed') {this.bulkUserForm.AssertionEmailsMixedDisabled=false} else {this.bulkUserForm.AssertionEmailsMixedDisabled=true}
                if (allalerts.pathchangeemails=='mixed') {this.bulkUserForm.PathChangeEmailsMixedDisabled=false} else {this.bulkUserForm.PathChangeEmailsMixedDisabled=true}
                if (allalerts.firstseenemails=='mixed') {this.bulkUserForm.FirstSeenEmailsMixedDisabled=false} else {this.bulkUserForm.FirstSeenEmailsMixedDisabled=true}


                try {
                    var prefsQuery = `query getControlledPrefixesQuery { getControlledPrefixes(
                        organisation: "` + this.organisation +`",
                        p_user: "` + this.$store.state.user.username + `"
                        filter_ip: "` + filter_ip + `"
                        filter_name: "` + filter_name + `"
                        orderby: "` + orderby + `"
                        descending: `+ descending +`
                        offset: `+ offset + `
                        limit: ` + limit + `

                    ) { 
                                    hostname
                                    ipv4_address
                                    ipv6_address
                                    asn
                                    description
                                    send_emails
                                    impact_setting
                                    own_path_first
                                    emails_opf
                     } 
                                    }`;
//                    console.log(prefsQuery);
                    const prefData = await API.graphql(graphqlOperation(prefsQuery));
                    var prefs = prefData.data.getControlledPrefixes;
//                    console.log(prefs)

                    if (prefs.length == 0 || prefs === undefined) {
                        this.userPrefixes = [];
                    } else {
                        for (var i = 0; i < prefs.length ; i++) {
                            try {
                                prefs[i].opf_split = prefs[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split.length ; j++ ) {
                                    prefs[i].opf_split[j] = prefs[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split = [true, false, false]
                            }

                            try {
                                prefs[i].opf_split_e = prefs[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split_e.length ; j++ ) {
                                    prefs[i].opf_split_e[j] = prefs[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split_e = [false, false, false]
                            }

                            if (prefs[i].send_emails == 1) {
                                prefs[i].send_emails = true;
                                prefs[i].email_icon = "check";
                            } else {
                                prefs[i].send_emails = false;
                                prefs[i].email_icon = "clear";
                            }
                            if (prefs[i].ipv4_address == '') {
                                prefs[i].ip_address = prefs[i].ipv6_address
                            } else {
                                prefs[i].ip_address = prefs[i].ipv4_address
                            }
                            // opf 0=assertions 1=paths 2=firstseens 3=intraorg
                            // opfe 0=assertions 1=paths 2=firstseens
                                this.user_download_prefixes.push({
                                'hostname': prefs[i].hostname,
                                'ip_prefix': prefs[i].ip_address,
                                'asn': prefs[i].asn,
                                'impact_setting': prefs[i].impact_setting,
                                'own_assertions': prefs[i].opf_split[0] ? 'Y' : 'N',
                                'intra_org_assertions': prefs[i].opf_split[3] ? 'Y' : 'N',
                                'own_assertions_emails': prefs[i].opf_split_e[0] ? 'Y' : 'N',
                                'path_changes': prefs[i].opf_split[1] ? 'Y' : 'N',
                                'path_changes_emails': prefs[i].opf_split_e[1] ? 'Y' : 'N',
                                'first_seens': prefs[i].opf_split[2] ? 'Y' : 'N',
                                'first_seens_emails': prefs[i].opf_split_e[2] ? 'Y' : 'N',
                                'description': prefs[i].description
                            })
                        }
                        this.userPrefixes = prefs;
                    }
                } catch(err) {
                    console.log( err)
                    console.log("An Error has occurred: " + err.errors[0].message)
                }
                
                this.loading2 = false;
                await this.getControlledPrefixCounts('user');   
        }
    },
    watch: {
        pagination_user: {
            handler () {
//                console.log("handler")
//                console.log(this.pagination_user);
                this.getData_user()
            },
            deep: true
        },
        pagination_org: {
            handler () {
//                console.log("handler");
//                console.log(this.pagination_org);
                this.getData_org();
            },
            deep: true
        },
        showAdvanced (n) {
//            console.log("setting show advanced settings")
//            console.log(n)
            this.$store.commit("setShowSettings", { 'advancedSettings': n });
//            console.log(this.$store.state.showSettings)
        }
    }
}
</script>

<style scoped>
    
    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    table.v-table tbody td, 
    table.v-table tbody th {
        height: 38px;
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    table.v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, 0.204);
    }

</style>
